import React, { useState, useEffect, useMemo } from 'react';
import {
  TextField, FormControl, Autocomplete, Table, LinearProgress, TableBody, TableHead, TableCell, TableRow, Dialog, DialogContent, FormHelperText, Tooltip, Slide, Grid, Box, Typography, useTheme, IconButton, Divider, ToggleButtonGroup,
} from '@mui/material';


import Stack from '@mui/material/Stack';
import axios from 'axios';
import { useCallback } from 'react';
import { debounce } from 'lodash';
import dayjs from "dayjs";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import ProductItemList from './productItemList';
import OrderCancel from './orderCancel';

import '../../../css/datepicker.css';
import Add from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import Closeicon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';

import SummaryLedger from './SummaryLedger';
import { usePriceList } from '../../../hooks/usePriceList ';
import { useTransporter } from '../../../hooks/useTransporter';
import { useHSNList } from '../../../hooks/useHSNList';
import { useMasterDataLoader } from '../../../hooks/useMasterDataLoader';
import SalesOrderReport from '../../../features/ordermanagement/reports/SalesOrderReport';

import useDefaultParameterConfig from '../../../hooks/useDefaultParameterConfig';
import calculateNoOfSheets from './hook/calculateNoOfSheets';
import CallAlertBar from '../../../Layout/Alertbar';
import ProductForm from './ProductForm';
import OrderActionButtons from './OrderActionMenu';
import { tokens } from '../../../theme/theme';
import { callApi } from '../../../utils/apiClient';
import { API_ENDPOINTS } from '../../../config/api/apiCall';
import CustomSnackbar from '../../../components/CustomSnackbar';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


// Your original initialValues function (unchanged, fixed underscore key)
const initialValues = () => {
  const company = parseInt(localStorage.getItem('companyid') ?? '0', 10);
  return {
    id: 0,
    ProductGroupID: 0,
    ProductSubGroupID: 0,
    ProductVarietyID: 0,
    Code: '',
    AuthorisedForSaleFlag: 'True',
    Color: 'white',
    GRADE: 'P',
    GSM: 0,
    BF: 0,
    WIDTH: 0,
    LENGTH: 0,
    MinLevel: 0,
    MaxLevel: 0,
    OpeningQty: 0,
    OpeningQtyValue: 0,
    ReOrderLevel: 0,
    ShelfLifeDays: 0,
    UnitOfMeasureCode: 'Kg',
    HSNCode: '',
    DiscountFlag: 'True',
    AllowNegativeInventoryFlag: 'False',
    DiscountType: '',
    DiscountRate: 0,
    TaxInclusiveSalePrice: 0,
    TaxExemptedFlag: 'True',
    MinimumSaleQty: 0,
    MaximumSaleQty: 0,
    RequestedQty: 0.00,
    UNITPRICE: 0.00,
    BILLINGRATE: 0.00,
    VARIETY: '',
    GRAIN: '',
    REELOD: 0,
    COREID: 0,
    NOOFSHEETS: 0,
    NOOFREELS: 0,
    ReamWeight: 0,
    ORDERQTY: 0.00,
    COQTY: 0.00,
    REMARKS: '',
    SPECIAL_INSTRUCTION: '',
    OrderType: '',
    STATUS: '',
    PriceListId: '',
    SProductID: 0,
    SICode: '',
    SIVariety: '',
    SIGSM: 0,
    SIWidth: 0,
    SILength: 0,
    SIColor: '',
    SIGrainDirection: '',
    SIPackageMode: '',
    SIRequested_Qty: 0.00,
    SIConfirmed_Qty: 0.00,
    SINoOfSheets: 0,
    SIReamWeight: 0,
    SIUnitPrice: 0,
    SIDiscountType: '',
    SIDiscount: 0,
    SIReelCoreID: 0,
    SIReelOD: 0,
    SIRemarks: '',
    SISpecialInstruction: '',
    SIOrderType: '',
    DMStatus: 'New',
    companyid: company,
    PackageType: '',
    PackageID: 0,
    UNITID: 1,
    UNITTYPE: 'Inch',
    SIUnit: 'Kg',
    Deckle_Qty: 0.00,
    Stock_Qty: 0.00,
    SIActualPrice: 0,
    CGSTPERSENTAGE: 0,
    SGSTPERSENTAGE: 0,
    IGSTPERSENTAGE: 0,
    ItemStatus: 'New',
  };
};


const AddNewOrder = ({ IndentId, ConfirmationOrderId, handlecallback }) => {


  // theme control

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);



  // Parent Roll  Alert Values
  const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
  const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
  const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
  const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');


  const [selectedSupplier, setSelectedSupplier] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [headervalueset, setheadervalueset] = useState('');
  const [Pricelistid, setPriceList] = useState('');
  const [SShipToCustomer, setSupplier] = useState(0);
  const [SBillToCustomer, setBillToCustomer] = useState(0);
  const [STransporter, setSTransporter] = useState('');
  const [DocumentSeries, setDocSequenceid] = useState(11);
  const [CompanyID, setCompanyID] = useState('');
  const [salesorderno, SetSalesorderno] = useState('Auto');
  const [SRefNo, SetSRefNo] = useState('');
  const [SRemarks, SetSRemarks] = useState('');
  const [region, SetSRegion] = useState('');
  const [regionDeliveryArea, SetRegionDeliveryArea] = useState('');

  const [SAmendmentReason, SetSAmendmentReason] = useState('');
  const [visibleAmendmentReason, setvisibleAmendmentReason] = useState(false);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [poDate, setPODate] = useState(dayjs());
  const [scheduleDate, setScheduleDate] = React.useState();
  const [btnSaveOrderText, setbtnSaveOrderText] = useState('Save');
  const [btnApproveOrdershow, setShow] = useState(false);
  const [btnSaveUpdateOrdershow, setbtnSaveUpdateOrdershow] = useState(true);
  const [btnAmendmentshow, setbtnAmendmentshow] = useState(false);
  const [btnAdditionalDetailshow, setbtnAdditionalDetailshow] = useState(true);
  const [btnAddProduct, setbtnAddProduct] = useState(true);
  const [btnPrint, setbtnPrint] = useState(false);
  const [btnCancel, setbtnCancel] = useState(false);
  const [rowEditAndDelete, setrowEditAndDelete] = useState(true);
  const [orderID, setorderID] = useState(0);
  const [confirmationID, setconfirmationID] = useState(0);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertsevierity, setalertsevierity] = useState('');
  const [billToCustomerError, setBillToCustomerError] = useState("");
  const [shipToCustomerError, setshipToCustomerError] = useState("");
  const [paymentTermError, setPaymentTermError] = useState("");
  const [transporterError, settransporterError] = useState("");
  const [priceListError, setpriceListError] = useState("");
  const [indentdateError, setindentdateError] = useState("");
  const [amendReasonError, setamendReasonError] = useState("");
  const [totalSIConfirmedQty, set_totalSIConfirmedQty] = useState(0);
  const [totalGrossAmount, set_totalGrossAmount] = useState(0);
  const [totaldiscountAmount, settotaldiscountAmount] = useState(0);
  const [totalAmount, settotalAmount] = useState(0);
  const [poDateError, setpoDateError] = useState("");

  const [customerAddress, setcustomerAddress] = useState("");
  const [supplierAddress, setsupplierAddress] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  // const [open, setOpen] = useState(false);
  const [openProductItem, setOpenProductItem] = useState(false);
  const [openAdditionalDetails, setopenAdditionalDetails] = useState(false);
  const [openCancelOrder, setopenCancelOrder] = useState(false);
  const [rows, setRows] = useState([]);
  const [Id_ShipmentMode, setId_ShipmentMode] = useState(null);
  const [Id_PaymentTerm, setId_PaymentTerm] = useState(null);
  const [Id_CreditTerm, setId_CreditTerm] = useState(null);
  const [Id_CreditTermRule, setId_CreditTermRule] = useState(null);
  const [userInteracted, setUserInteracted] = useState(false);
  const [openApproveConfirmation, setOpenApproveConfirmation] = useState(false);
  const [openCancelConfirmation, setOpenCancelConfirmation] = useState(false);
  const [openAmendmentConfirmation, setOpenAmendmentConfirmation] = useState(false);
  const [progress, setProgress] = React.useState(0);
  const [buffer, setBuffer] = React.useState(10);
  const [loading, setLoading] = React.useState(false);
  const progressRef = React.useRef(() => { });



  const [selectedRows, setSelectedRows] = useState([]);


  const [open, setOpen] = useState(false);

  const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;
  const [openNew, setOpenNew] = useState(false);

  const [selectedProductgroup, setSelectedProductgroup] = useState('');
  const [selectedProductsubgroup, setSelectedProductsubgroup] = useState('');
  const [selectedvariety, setSelectedvariety] = useState('');
  const [selectedgrade, setSelectedgrade] = useState('');
  const [selectedhsn, setSelectedhsn] = useState('');
  const [selectedgrain, setSelectedgrain] = useState('');
  const [selectedUnit, setSelectedUnit] = useState('');
  const [selectedcoreid, setSelectedcoreid] = useState('');
  const [selectedremarks, setSelectedremarks] = useState('');
  const [selectedDiscountType, setselectedDiscountType] = useState('');
  const [selectedOrderType, setselectedOrderType] = useState('');
  const [selectedPackageType, setselectedPackageType] = useState('');
  const [optionsProductSubgroup, setOptionsProductSubgroup] = useState([]);
  const [optionsVariety, setOptionsVariety] = useState([]);

  //validation declaration
  const [GSMError, setGSMError] = useState("");
  const [WidthError, setWidthError] = useState("");
  const [GradeError, setGradeError] = useState("");
  const [HSNError, setHSNError] = useState("");

  const [RequiredQtyError, setRequiredQtyError] = useState("");
  const [COQtyError, setCOQtyError] = useState("");
  const [UnitpriceError, setUnitpriceError] = useState("");
  const [BillingRateError, setBillingRateError] = useState("");
  const [PackageTypeError, setPackageTypeError] = useState("");

  const [ProductGroupError, setProductGroupError] = useState("");
  const [ProductSubGroupError, setProductSubGroupError] = useState("");
  const [ProductVarietyError, setProductVarietyError] = useState("");
  const [NoOfSheetsError, setNoOfSheetsError] = useState("");
  const [ReelODError, setReelODError] = useState("");
  const [CoreIDError, setCoreIDError] = useState("");

  const [disabledReelOD, setDisabledReelOD] = useState(true);
  const [disabledCoreID, setDisabledCoreID] = useState(true);
  const [disabledNoofSheets, setDisabledNoofSheets] = useState(true);
  const [disabledNoofReels, setDisabledNoofReels] = useState(true);
  const [userInteractedExistingItem, setuserInteractedExistingItem] = useState(false);
  const [pageTitle, SetpageTitle] = useState('Add Product Detail');
  const [mode, setMode] = useState('add'); // 'add' | 'edit'

  const [current, setCurrent] = useState(null); // row or null

  const [dataSupplier, setdataSupplier] = useState([]);
  const [dataCustomer, setdataCustomer] = useState([]);
  const [dataProductgroup, setdataProductgroup] = useState([]);
  const [dataGrade, setdataGrade] = useState([]);

  const [datagrain, setdatagrain] = useState([]);
  const [dataCoreID, setdataCoreID] = useState([]);
  const [dataRemarks, setdataRemarks] = useState([]);
  const [dataDiscountType, setdataDiscountType] = useState([]);
  const [dataOrderType, setdataOrderType] = useState([]);

  const [dataPackageType, setdataPackageType] = useState([]);
  const [dataShipmentmode, setdataShipmentmode] = useState([]);
  const [dataPaymentterm, setdataPaymentterm] = useState([]);
  const [dataCreditterm, setdataCreditterm] = useState([]);
  const [dataCredittermRule, setdataCredittermRule] = useState([]);
  const [dataUnitType, setdataUnitType] = useState();

  // payment terms
  const [paymentTerms, setPaymentTerms] = useState([]);
  const [isPaymentTermsLoaded, setIsPaymentTermsLoaded] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isCreditTermsModalOpen, setIsCreditTermsModalOpen] = useState(false);


  const [selectedShipmentMode, setSelectedShipmentMode] = useState('');
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState('');
  const [selectedCreditTerm, setSelectedCreditTerm] = useState('');
  const [selectedCreditTermRule, setSelectedCreditTermRule] = useState('');

  const masterGroup = '';
  const [FinancierYear, setFinancierYear] = useState(1);

  const [taxMode, setTaxMode] = useState(0);
  const [insurance, setInsurance] = useState(0.0);
  const [frightPerMT, setFrieightPerMT] = useState(0.0);
  const [serviceCharge, setServiceCharge] = useState(0.0);

  const [viewReport, setViewReport] = useState(false);
  const [viewOrder, setViewOrder] = useState(true);
  const [weightPerCMInKg, setWeightPerCMInKg] = useState(0.0);
  const [weightPerInchInKg, setWeightPerInchInKg] = useState(0.0);

  const commonParams = {
    FinancierYear,
    masterGroup,
    CompanyID: localStorage.getItem('companyid'),
  };

  // hooks 
  const { dataPriceList, selectedPriceList, setSelectedPriceList, loadPriceList, } = usePriceList(commonParams);
  const { dataTransporter, selectedTransporter, setSelectedTransporter, loadTransporter, } = useTransporter(commonParams);
  const { dataHsn, loadHSNCode } = useHSNList();
  const { loadMasterData } = useMasterDataLoader();
  const { defaultParameterConfig } = useDefaultParameterConfig();
  const [initialized, setInitialized] = useState(false);

  const [defaultValues, setDefaultValues] = React.useState({
    GRADE: 'Primary',
    REELOD: 100,
    COREID: 3,
    NOOFSHEETS: 144,
    UNITPRICE: 1,
    UNITID: 'inches',
    GRAIN: 'S',
    DiscountType: 'Flat',
    OrderType: 'Domestic',
    PackageType: 'Bundle',
  });



  useEffect(() => {
    if (!initialized && defaultParameterConfig?.length > 0) {
      const reel_od = defaultParameterConfig.find((e) => e.p_name === "Reel OD");
      const core_od = defaultParameterConfig.find((e) => e.p_name === "Core ID");
      const no_of_sheets = defaultParameterConfig.find((e) => e.p_name === "No of Sheets");
      const unit_price = defaultParameterConfig.find((e) => e.p_name === "Unit Price");

      const set_wt_per_cm_kg = defaultParameterConfig.find((e) => e.p_name === "Reel weight calculation");

      setWeightPerCMInKg(set_wt_per_cm_kg.p_minvalue);
      setWeightPerInchInKg(set_wt_per_cm_kg.p_maxvalue);


      setDefaultValues((prev) => ({
        ...prev,
        REELOD: reel_od?.p_default_value || 0,
        COREID: core_od?.p_default_value || 0,

        UNITPRICE: unit_price?.p_default_value || 0,
      }));
      setInitialized(true);

    }
  }, [defaultParameterConfig]); // run only when config changes


  const handleSelectShipmentMode = (event, newValue) => {
    if (newValue !== undefined && newValue !== null) {
      setSelectedShipmentMode(newValue);
      setId_ShipmentMode(newValue.CodeId);
    }
  };

  const handleSelectPaymentTerm = (event, newValue) => {
    if (newValue !== undefined && newValue !== null) {
      setSelectedPaymentTerm(newValue);
      setId_PaymentTerm(newValue.CodeId);
    }
  };

  const handleSelectCreditTerm = (event, newValue) => {
    if (newValue !== undefined && newValue !== null) {
      setSelectedCreditTerm(newValue);
      setId_CreditTerm(newValue.CodeId);
    }
  };

  const handleSelectCreditTermRule = (event, newValue) => {
    if (newValue !== undefined && newValue !== null) {
      setSelectedCreditTermRule(newValue);
      setId_CreditTermRule(newValue.CodeId);
    }
  };


  useEffect(() => {
    const retrievedUserID = localStorage.getItem('userID');
    if (retrievedUserID) {
      setCompanyID(localStorage.getItem('companyid'));
    }
  }, []); // Empty dependency array to run only once on mount


  React.useEffect(() => {
    progressRef.current = () => {
      if (progress > 100) {
        setProgress(0);
        setBuffer(10);
      } else {
        const diff = Math.random() * 10;
        const diff2 = Math.random() * 10;
        setProgress(progress + diff);
        setBuffer(progress + diff + diff2);
      }
    };
  });

  React.useEffect(() => {
    if (loading) {
      const timer = setInterval(() => {
        progressRef.current();
      }, 500);

      return () => {
        clearInterval(timer);
      };
    }
  }, [loading]);



  const [rowToEdit, setRowToEdit] = useState(null);

  const showError = (message, severity) => {
    setAlertMessage(message);
    setalertsevierity(severity);
    showSnackbar();
    return true;
  };

  const handleViewReport = () => {

    let valOrderID = 0;
    let valConfirmationID = 0;

    if (IndentId === '0') {
      valOrderID = orderID;
      valConfirmationID = confirmationID;
    }
    else {
      valOrderID = IndentId;
      valConfirmationID = ConfirmationOrderId;
    }

    if (headervalueset === 'Approved Order' || headervalueset === 'Processed Order') {

      if (valConfirmationID > 0) {
        const requestBody = {
          SConfirmationId_API: valConfirmationID,
          ConstructedGlobalValues: {
            COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
            COMPANY_ID: CompanyID,
          },
        };

        callApi(API_ENDPOINTS.GenerateDataForOrderReport, 'POST', { 'Content-Type': 'application/json' }, requestBody)
          .then(data => {
            if (data) {
              console.log(data);
              setOrderData(data);
            }
          })
          .catch(error => {
            alert(error.message);
          });

        setViewReport(true);
        setViewOrder(false);
      }
    }
    else {
      showError('The invoice cannot be generated for this order. Please check the order status', 'warning')
    }

  };


  // sample input
  // const orderData = {
  //   companyName: "NETIQUE INFOTECH PRIVATE LIMITED",
  //   companyAddress: "8.5 KM Jansath Road, Muzaffarnagar, UP, India",
  //   companyGST: "09AABCR1065J1ZC",
  //   billTo: {
  //     name: "A S PACKERS PROVIDERS (P) LTD",
  //     address: "Plot No.181, Gali No 2, Krishna Colony, Faridabad, Haryana",
  //     gst: "06AAKCA6829J2ZB",
  //     state: "Haryana"
  //   },
  //   shipTo: {
  //     name: "A S PACKERS PROVIDERS (P) LTD",
  //     address: "Plot No.181, Gali No 2, Krishna Colony, Faridabad, Haryana",
  //     gst: "06AAKCA6829J2ZB",
  //     state: "Haryana"
  //   },
  //   confirmationNo: "AP-183-2025",
  //   confirmationDate: "16-Jun-2025",
  //   poNo: "PO1234",
  //   poDate: "10-Jun-2025",
  //   items: [
  //     {
  //       variety: "AURA1",
  //       gsm: "10.00",
  //       size: "23.00 x 25.00",
  //       uom: "KG",
  //       unitPrice: "5000",
  //       reels: "12",
  //       total: "50000"
  //     }
  //   ],
  //   discount: "0.00",
  //   assessableValue: "50000.00",
  //   igstRate: "12.00",
  //   igstValue: "6000.00",
  //   totalValue: "56000.00",
  //   amountInWords: "Fifty Six Thousand Rupees Only",
  //   bank: {
  //     accNo: "50200070318663",
  //     ifsc: "HDFC0004432",
  //     name: "HDFC Bank Ltd, Bhagwanpur"
  //   }
  // };

  const [orderData, setOrderData] = useState([]);





  const ShowCOReport = async (requestBody) => {
    try {

      const response = await axios.post(API_ENDPOINTS.generateConfirmationOrder,
        requestBody,
        {
          responseType: 'arraybuffer' // Important to receive binary data
        }
      );


      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'report.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      showError('Confirmation order report exported successfully..!', 'success')

    } catch (error) {
      console.error('Error generating report:', error);

    } finally {
      setLoading(false);
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = () => {
    setSnackbarOpen(true);
  };

  const hideButton = () => {
    setShow(true);
  };


  const handleDeleteRow = (targetRow) => {
    const deletedRow = rows.find((row) => row.id === targetRow.id);
    if (!deletedRow) return;

    // Validations
    if (deletedRow.ItemTotalStock > 0) {
      showError("This item cannot be removed from the order as the item has stock allocated.", "Warning");
      return;
    }
    if (deletedRow.LineClosed) {
      showError("This item cannot be removed from the Order as the item is closed.", "Warning");
      return;
    }
    if (deletedRow.DeleteAllowed) {
      showError("This item cannot be removed from the Order as the item is sent to deckle matching.", "Warning");
      return;
    }
    if (deletedRow.ItemCancelled) {
      showError("This item cannot be removed from the Order as the item is already cancelled.", "Warning");
      return;
    }

    // Ask for confirmation
    const confirmDelete = window.confirm("Do you want to remove this line item?");
    if (!confirmDelete) return;

    // Delete if confirmed
    setRows((prevRows) => prevRows.filter((row) => row.id !== targetRow.id));
  };



  const handleCancelRow = (row) => {
    // Block cancel if already sent to deckle matching
    if (row.ItemStatus === 'Decklematching') {
      alert("Item(s) sent to deckle matching cannot be cancelled.");
      return;
    }

    // Update cancellation flags in your state
    setRows((prevRows) =>
      prevRows.map((r) =>
        r.id === row.id
          ? {
            ...r,
            ItemCancelled: true,
            ItemStatus: "Marked for cancellation",
          }
          : r
      )
    );

    console.log("Row marked for cancellation:", row.id);
  };



  const handleEditRow = (rowData) => {
    setRowToEdit(rowData);
    setOpen(true);

  };



  const handleSubmit = async (newRow) => {
    const newRowWithId = {
      ...newRow,
      id: newRow.id || rows.length + 1, // keep existing id if editing
    };

    if (mode === "add") {
      // ✅ Check for duplicate product by key fields
      const isDuplicate = rows.some((row) =>
        row.ProductVarietyID === newRowWithId.ProductVarietyID &&
        row.GRADE === newRowWithId.GRADE &&
        row.GSM === newRowWithId.GSM &&
        row.BF === newRowWithId.BF &&
        row.WIDTH === newRowWithId.WIDTH &&
        row.LENGTH === newRowWithId.LENGTH
      );

      if (isDuplicate) {
        alert("This product with the same attributes already exists.");
        return; // skip adding
      }

      // Add new row
      setRows((prev) => [...prev, newRowWithId]);
      openAdd();

    } else if (mode === "edit") {
      // Update existing row by ID
      const updatedRows = rows.map((row) =>
        row.id === newRowWithId.id ? { ...row, ...newRowWithId } : row
      );
      setRows(updatedRows);
      // openAdd();
    }
    // Reset edit state
    setRowToEdit(null);
  };

  const [totals, setTotals] = useState({
    totalQtyKg: 0,
    grossWeight: 0,
    grossAmount: 0,
    discountAmount: 0,
    taxableAmount: 0,
    totalAmount: 0,
    insuranceRatePct: 0,
    insuranceAmount: 0,
    freightAmountPerMT: 0,
    freightAmount: 0,
    serviceChargePct: 0,
    sChargeAmount: 0,
    cessAmount: 0,
    taxAmount: 0,
    roundOff: 0,
    netAmount: 0,
    igstpct: 0,
    igstamount: 0,
    cgstpct: 0,
    cgstamount: 0,
    sgstpct: 0,
    sgstpct: 0,
  });

  const handlecalculation = (rows) => {
    let totals = {
      totalQtyKg: 0,
      grossWeight: 0,
      grossAmount: 0,
      discountAmount: 0,
      taxableAmount: 0,
      totalAmount: 0,
      insuranceRatePct: 0,
      insuranceAmount: 0,
      freightAmountPerMT: 0,
      freightAmount: 0,
      serviceChargePct: 0,
      sChargeAmount: 0,
      cessAmount: 0,
      taxAmount: 0,
      roundOff: 0,
      netAmount: 0,
      igstpct: 0,
      igstamount: 0,
      cgstpct: 0,
      cgstamount: 0,
      sgstpct: 0,
      sgstamount: 0,
    };

    rows.forEach((row) => {
      const qty = Number(row.COQTY || row.RequestedQty || 0);
      const unitPrice = Number(row.UNITPRICE || row.SIUnitPrice || 0);
      const reamWeight = Number(row.ReamWeight || row.SIReamWeight || 0);
      const discountRate = Number(row.DiscountRate || row.SIDiscount || 0);
      const discountType = row.DiscountType || row.SIDiscountType || "Flat";

      const grossWeight = qty * reamWeight;
      const grossAmount = qty * unitPrice;

      let discountAmount = 0;
      if (discountType === "Flat") {
        discountAmount = qty * discountRate;
      } else if (discountType === "Rate") {
        discountAmount = (grossAmount * discountRate) / 100;
      }

      const taxableAmount = grossAmount - discountAmount;
      const totalAmount = taxableAmount;

      totals.totalQtyKg += qty;
      totals.grossWeight += grossWeight;
      totals.grossAmount += grossAmount;
      totals.discountAmount += discountAmount;
      totals.taxableAmount += taxableAmount;
      totals.totalAmount += totalAmount;

      // Add-ons
      let LChargeAmount = (taxableAmount * serviceCharge) / 100;
      let WTperMT = qty / 1000;
      let LFrightAmount = WTperMT * frightPerMT;
      let LInsuranceAmount = (taxableAmount * insurance) / 100;

      let LTaxableAmount = taxableAmount + LInsuranceAmount + LFrightAmount + LChargeAmount;

      let IGSTAmount = 0, CGSTAmount = 0, SGSTAmount = 0;
      let IGSTPercentage = 0, CGSTPercentage = 0, SGSTPercentage = 0;

      // Tax calculation
      let taxAmount = 0;

      if (taxMode === 0) {
        if (row.CGSTPERSENTAGE > 0) {
          taxAmount += (LTaxableAmount * row.CGSTPERSENTAGE) / 100;
          CGSTPercentage = row.CGSTPERSENTAGE;
          CGSTAmount = (LTaxableAmount * row.CGSTPERSENTAGE) / 100;
        }
        if (row.SGSTPERSENTAGE > 0) {
          taxAmount += (LTaxableAmount * row.SGSTPERSENTAGE) / 100;
          SGSTPercentage = row.SGSTPERSENTAGE;
          SGSTAmount = (LTaxableAmount * row.SGSTPERSENTAGE) / 100;
        }
      } else {
        if (row.IGSTPERSENTAGE > 0) {
          taxAmount += (LTaxableAmount * row.IGSTPERSENTAGE) / 100;
          IGSTPercentage = row.IGSTPERSENTAGE;
          IGSTAmount = (LTaxableAmount * row.IGSTPERSENTAGE) / 100;
        }
      }

      totals.taxAmount += taxAmount;

      // // Net amount & round-off
      // let netamountRaw = LTaxableAmount +  totals.taxAmount ;
      // totals.netAmount = Math.round(netamountRaw);
      // totals.roundOff = Number((totals.netAmount - netamountRaw).toFixed(2));

      totals.igstpct = IGSTPercentage;
      totals.cgstpct = CGSTPercentage
      totals.sgstpct = SGSTPercentage;
      totals.igstamount += IGSTAmount;
      totals.cgstamount += CGSTAmount;
      totals.sgstamount += SGSTAmount;

    });

    // ✅ Apply charges after loop
    totals.sChargeAmount = (totals.totalAmount * serviceCharge) / 100;
    totals.serviceChargePct = serviceCharge;

    const totalweightinMT = totals.totalQtyKg / 1000;
    totals.freightAmount = totalweightinMT * frightPerMT;
    totals.freightAmountPerMT = frightPerMT;

    totals.insuranceAmount = (totals.totalAmount * insurance) / 100;
    totals.insuranceRatePct = insurance;


    // ✅ New taxable amount formula
    totals.taxableAmount =
      totals.totalAmount +
      totals.insuranceAmount +
      totals.freightAmount +
      totals.sChargeAmount;

    // Net amount & round-off
    let netamountRaw = totals.taxableAmount + totals.taxAmount;
    totals.netAmount = Math.round(netamountRaw);
    totals.roundOff = Number((totals.netAmount - netamountRaw).toFixed(2));

    return totals;
  };
  // 🔥 Auto-trigger when rows or charges change
  useEffect(() => {
    if (rows.length > 0) {
      setTotals(handlecalculation(rows));
    }
  }, [rows, insurance, frightPerMT, serviceCharge]);


  const handleProductItemList = (selectedcoreid, rowStatus) => {
    const requestBody = {
      filter: {
        FinancierYear: FinancierYear,
        CompanyID: CompanyID,
      },
      sList: selectedcoreid,
      pricelistid: Pricelistid,
    };

    fetch(API_ENDPOINTS.getProductItems, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Unable to get the product items..!');
        }
        return response.json();
      })
      .then(data => {
        // Convert API data to rows compatible with the data grid        
        if (rowStatus === 'new') {
          const apiRows = data.map((rows, index) => ({
            ...rows,
            id: index + 1, // You can use a more robust way to generate an ID
          }));
          setRows(apiRows);
        }
        else {
          const existingProductIds = new Set(rows.map(row => row.SProductID));
          const maxId = Math.max(...rows.map((row) => row.id), 0);
          const apiRows1 = data
            .filter(row => !existingProductIds.has(row.SProductID)) // Filter out rows with existing product IDs
            .map((row, index) => ({
              ...row,
              id: maxId + index + 1, // Generate a new id based on the maximum existing id
            }));
          setRows((prevRows) => [...prevRows, ...apiRows1]);
        }
      })
      .catch(error => {
        showError('Unable to get the product items..!', 'error');
      });
  }

  const handleCancelOrder = (Reason, selectedDate) => {
    if (IndentId !== '0') {
      let valOrderID = 0;
      let valConfirmationID = 0;

      if (IndentId === '0') {
        valOrderID = orderID;
        valConfirmationID = confirmationID;
      }
      else {
        valOrderID = IndentId;
        valConfirmationID = ConfirmationOrderId;
      }

      const orderData = {
        SOrderId: valOrderID,
        SConfirmationId_API: valConfirmationID,
        SCancelledReason: Reason,
        SCancelledDate: selectedDate,
      };

      const requestBody = {
        orderData: orderData,
        DocumentSeries: DocumentSeries,
        filter: {
          FinancierYear: FinancierYear,
          CompanyID: CompanyID,
        },
      };

      fetch(API_ENDPOINTS.cancelOrderDetails, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Unable to Cancel the order');
          }
          return response.json();
        })
        .then(data => {
          setOpenAlert(true);
          showError(data.ReturnValidationMessage, 'info');
          setheadervalueset('Order Cancelled');

          setbtnCancel(false);
          setbtnPrint(false);
          setbtnAmendmentshow(false);
          setShow(false); //Approve button           
          setbtnSaveUpdateOrdershow(false);
          setbtnAddProduct(false);
          setrowEditAndDelete(false);
          setbtnAdditionalDetailshow(false);
        })
        .catch(error => {
          showError('Unable to Cancel the order', 'error');
        });
    }
  };




  const openProductItemList = () => {
    setOpenProductItem(true);
    setRowToEdit(null);
  };

  const openOrderAdditionalData = () => {
    setopenAdditionalDetails(true);
  };

  const openOrderCancel = () => {

    // Check if any item has status 'Decklematching'
    const hasDeckleMatching = rows.some(
      (row) => row.ItemStatus?.toLowerCase() === "decklematching"
    );
    if (hasDeckleMatching) {
      showError(
        "Item(s) sent to deckle matching. Full cancellation of the order is not allowed.", "Warning"
      );
      return;
    }

    // Check if any item has stock assigned
    const hasStock = rows.some((row) => (row.ItemTotalStock || 0) > 0);
    if (hasStock) {
      showError(
        "Item(s) have stock assigned. Please transfer the stock before cancelling the order.", "Warning"
      );
      return;
    }
    setopenCancelOrder(true);
    handleCloseCancelConfirmation();
  };

  const validateFieldAmend = (value, setError, errorMessage) => {
    if (value === '') {
      setError(errorMessage);
      return true;
    }
    setError("");
    return false;
  };

  const AmendmentofOrder = async () => {
    if (IndentId !== '0') {
      let valOrderID = 0;
      let valConfirmationID = 0;
      let formDirty = false;

      formDirty = validateFieldAmend(SAmendmentReason, setamendReasonError, "Amendment Reason is required") || formDirty;

      if (!formDirty) {
        if (IndentId === '0') {
          valOrderID = orderID;
          valConfirmationID = confirmationID;
        }
        else {
          valOrderID = IndentId;
          valConfirmationID = ConfirmationOrderId;
        }

        const orderData = {
          SOrderId: valOrderID,
          SConfirmationId_API: valConfirmationID,
          SAmendmentReason: SAmendmentReason,
        };

        const requestBody = {
          orderData: orderData,
          DocumentSeries: DocumentSeries,
          filter: {
            FinancierYear: FinancierYear,
            CompanyID: CompanyID,
          },
        };

        await callApi(API_ENDPOINTS.amendOrderDetails, 'POST', { 'Content-Type': 'application/json' }, requestBody)
          .then(data => {
            if (!data) {
              showError('No response received from server', 'error');
              return;
            }

            setOpenAlert(true);
            showError(data.ReturnValidationMessage, 'info');

            setbtnSaveUpdateOrdershow(true);
            setbtnAddProduct(true);
            setrowEditAndDelete(true);
            setShow(true); //Approve button                             
            setbtnCancel(true);
            setbtnAdditionalDetailshow(true);
            setheadervalueset('Update Order');
            setbtnSaveOrderText('Update'); //button text (ie., save,update)
            setbtnAmendmentshow(false);
            setvisibleAmendmentReason(false);
            setbtnPrint(false);
          })
          .catch(error => {
            showError('Unable to amend the order', 'error');
          });
      }

      handleCloseAmendmentConfirmation();
    }
  };



  const closePopupProductItemList = () => {
    setOpenProductItem(false);
    onsubmit = { handleProductItemList }
  };

  const closeProductItemListPopup = () => {
    setOpenProductItem(false);
  };



  const closeCancelOrderPopup = () => {
    setopenCancelOrder(false);
  };

  const fetchAddressData = (SPartyID, SPartyAddressType) => {
    const cls_Party = { SPartyID, SPartyAddressType };

    return fetch(API_ENDPOINTS.getPartyAddress, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(cls_Party)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Unable to get the address..!');
        }
        return response.json();
      });
  };

  const getAddressString = (data) => {
    return `Address: ${data[0].LabelValueColumn2}, ${data[1].LabelValueColumn2} | State: ${data[2].LabelNameColumn2} | City: ${data[2].LabelValueColumn2} | Postal Code: ${data[3].LabelValue}`;
  };

  const handleSelectPricelist = (event, newValue) => {
    if (newValue !== undefined && newValue !== null) {
      setSelectedPriceList(newValue);
      setPriceList(newValue.CodeId);
      setOpenAlert(false);
    }
  };

  const handleSelectSupplier = (event, newValue) => {
    if (newValue !== undefined && newValue !== null) {
      setSelectedSupplier(newValue);
      setSupplier(newValue.CodeId);

      const SPartyID = newValue.CodeId;
      const SPartyAddressType = "Shipping";

      fetchAddressData(SPartyID, SPartyAddressType)
        .then(data => {
          setsupplierAddress("Address: " + getAddressString(data));
        })
        .catch(error => {
          showError('Unable to select supplier properly.!', 'error');
        });
    }
  };

  const handleSelectCustomer = (event, newValue) => {
    if (newValue !== undefined && newValue !== null) {
      setSelectedCustomer(newValue);
      setBillToCustomer(newValue.CodeId);

      if (dataSupplier.length > 0) {
        const codeIdValue = newValue.CodeId;
        const stringCodeIdValue = String(codeIdValue);
        const filteredData = dataSupplier.filter((item) => item.CodeId === stringCodeIdValue);

        if (filteredData.length > 0) {
          setSelectedSupplier(filteredData[0]);
          setSupplier(newValue.CodeId);
        }
      }

      const SPartyID = newValue.CodeId;
      const SPartyAddressType = "Billing";

      fetchAddressData(SPartyID, SPartyAddressType)
        .then(data => {
          setcustomerAddress("Address: " + getAddressString(data));
          setsupplierAddress("Address: " + getAddressString(data));

          if (!localStorage.getItem('companyState')) {
            showError('Unable to get the Company State properly.!', 'error');
            return;
          }
          let companyState = localStorage.getItem('companyState');

          if (data[2].LabelValue !== companyState) {
            setTaxMode(1);
          } else {
            setTaxMode(0);
          }
        })
        .catch(error => {
          showError('Unable to get the address properly.!', 'error');
        });
    }
  };

  const handleSelectTransporter = (event, newValue) => {
    if (newValue !== undefined && newValue !== null) {
      setSelectedTransporter(newValue);
      setSTransporter(newValue.CodeId);
    }
  };

  const handleSelectPoNo = (e) => {
    SetSRefNo(e.target.value);
  }
  const handleSelectRemarks = (e) => {
    SetSRemarks(e.target.value);
  }

  const handleSelectAmendmentReason = (e) => {
    SetSAmendmentReason(e.target.value);
  }

  const handleDateChange = (date) => {
    setSelectedDate(dayjs(date));
  };
  const handlePODateChange = (date) => {
    setPODate(dayjs(date));
  };

  const handleScheduleDateChange = (date) => {
    const selectedDate = new Date(date); // Assuming 'date' is a valid date string
    const formattedDate = selectedDate.toLocaleDateString('en-US');
    setScheduleDate(formattedDate);
  };


  useEffect(() => {
    const loadAllData = async () => {
      try {
        await Promise.all([
          loadPriceList(),
          loadTransporter(),
          loadHSNCode(),
        ]);
      } catch (error) {
        console.error("Error loading data:", error);
      }
    };

    loadAllData();
  }, []);



  const handleFilterAndSetSelection = (dataArray, setValueFunction, codeIdField, data, setCodeId) => {
    if (dataArray.length > 0) {
      const codeIdValue = data[0]?.[codeIdField];
      const stringCodeIdValue = String(codeIdValue);
      const filteredData = dataArray.filter((item) => item.CodeId === stringCodeIdValue);

      if (filteredData.length > 0) {
        setValueFunction(filteredData[0]);
        setCodeId(codeIdValue);
        setUserInteracted(true);
      }

      if (codeIdField === 'SBillToCustomer') {
        SetSalesorderno(data[0].SConfirmationNo);
        SetSRefNo(data[0].SRefNo);
        SetSRemarks(data[0].SRemarks);
        setScheduleDate(data[0].SScheduledDate);
        const selectedDate = new Date(data[0].SIndentDate); // Assuming 'date' is a valid date string
        setSelectedDate(selectedDate);


        const SPartyID = codeIdValue;
        const SPartyAddressType = "Billing";

        fetchAddressData(SPartyID, SPartyAddressType)
          .then(data => {
            setcustomerAddress("Address: " + getAddressString(data));
            setsupplierAddress("Address: " + getAddressString(data));

            if (!localStorage.getItem('companyState')) {
              showError('Unable to get the Company State properly.!', 'error');
              return;
            }
            let companyState = localStorage.getItem('companyState');

            if (data[2].LabelValue !== companyState) {
              setTaxMode(1);
            } else {
              setTaxMode(0);
            }
          })
          .catch(error => {
            showError('Unable to get the address properly.!', 'error');
          });
      }
    }
  };








  useEffect(() => {
    //CalculateSummaryForProducts();


    if (IndentId !== 0 && (salesorderno === 'Auto' || salesorderno === '')) {
      const orderData = {
        SOrderId: IndentId,
        SConfirmationId_API: ConfirmationOrderId,
      };

      const requestBody = {
        orderData: orderData,
        DocumentSeries: DocumentSeries,
        filter: {
          FinancierYear: FinancierYear,
          CompanyID: localStorage.getItem('companyid'),
        },
      };

      fetch(API_ENDPOINTS.loadConfirmationOrderDetail, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Unable to get order details.!');
          }
          return response.json();
        })
        .then(data => {
          if (userInteracted === false) {
            handleFilterAndSetSelection(dataCustomer, setSelectedCustomer, 'SBillToCustomer', data, setBillToCustomer);
            handleFilterAndSetSelection(dataSupplier, setSelectedSupplier, 'SShipToCustomer', data, setSupplier);
            handleFilterAndSetSelection(dataPriceList, setSelectedPriceList, 'SPriceList', data, setPriceList);
            handleFilterAndSetSelection(dataTransporter, setSelectedTransporter, 'STransporter', data, setSTransporter);
            handleFilterAndSetSelection(dataShipmentmode, setSelectedShipmentMode, 'SShipmentMode', data, setId_ShipmentMode);
            handleFilterAndSetSelection(dataPaymentterm, setSelectedPaymentTerm, 'SPaymentTerm', data, setId_PaymentTerm);
            handleFilterAndSetSelection(dataCreditterm, setSelectedCreditTerm, 'SCreditTerm', data, setId_CreditTerm);
            handleFilterAndSetSelection(dataCredittermRule, setSelectedCreditTermRule, 'SCreditLimitRule', data, setId_CreditTermRule);

          }

          // fields data 
          setPODate(data[0].SPODate);
          SetSRegion(data[0].SRegion);
          SetRegionDeliveryArea(data[0].SDeliveryArea);

          const dbData = data[0].SSalesOrderSummary[0];
          if (dbData) {
            setInsurance(dbData.insurance_rate_pct);
            setFrieightPerMT(dbData.freight_amount_per_mt);
            setServiceCharge(dbData.service_charge_pct);

            setTotals({
              totalQtyKg: dbData.total_qty_kg,
              grossWeight: dbData.gross_weight,
              grossAmount: dbData.gross_amount,
              discountAmount: dbData.discount_amount,
              taxableAmount: dbData.taxable_amount,
              totalAmount: dbData.total_amount,
              insuranceRatePct: dbData.insurance_rate_pct,
              insuranceAmount: dbData.insurance_amount,
              freightAmountPerMT: dbData.freight_amount_per_mt,
              freightAmount: dbData.freight_amount,
              serviceChargePct: dbData.service_charge_pct,
              sChargeAmount: dbData.scharge_amount,
              cessAmount: dbData.cess_amount,
              taxAmount: dbData.tax_amount,
              roundOff: dbData.round_off,
              netAmount: dbData.net_amount,
            });
          }


          const apiRows = data[0].SSalesOrderItems.map((rows, index) => ({
            ...rows,
            id: index + 1, // You can use a more robust way to generate an ID
            // new data 
          }));
          setRows(apiRows);

          setbtnCancel(false);
          setbtnPrint(false);
          setbtnAmendmentshow(false);
          setShow(false); //Approve button           
          setbtnSaveUpdateOrdershow(false);
          setbtnAddProduct(false);
          setrowEditAndDelete(false);
          setbtnAdditionalDetailshow(false);
          setvisibleAmendmentReason(false);

          const SOrderStatus = data[0].SOrderStatus;

          if (SOrderStatus === '[new]') {
            setbtnSaveUpdateOrdershow(true);
            setbtnAddProduct(true);
            setrowEditAndDelete(true);
            setbtnCancel(true);
            setbtnAdditionalDetailshow(true);
            setheadervalueset('Add Order');
          }
          else if (SOrderStatus === 'New' || SOrderStatus === 'UnderAmendment') {
            setbtnSaveUpdateOrdershow(true);
            setbtnAddProduct(true);
            setrowEditAndDelete(true);
            setShow(true); // Approve button                             
            setbtnCancel(true);
            setbtnAdditionalDetailshow(true);
            setheadervalueset('Update Order');
            setbtnSaveOrderText('Update'); // button text (ie., save,update)
          }
          else if (SOrderStatus === 'Approved') {
            setbtnAmendmentshow(true);
            setbtnPrint(true);
            setbtnCancel(true);
            setheadervalueset('Approved Order');
            setvisibleAmendmentReason(true);
          }
          else if (SOrderStatus === 'Processed') {
            setbtnPrint(true);
            setheadervalueset('Processed Order');
          }
          else if (SOrderStatus === 'Cancelled') {
            setheadervalueset('Order Cancelled');
          }
        })
        .catch(error => {
          showError('Unable to get the order details properly.!', 'error');
        });
    }
    else {
      if (headervalueset === '')
        setheadervalueset('Add Order');
    }
  }, [IndentId, ConfirmationOrderId, DocumentSeries, FinancierYear, CompanyID, dataCustomer]);






  // validate and submit data 
  const handleOrdersSubmit = (e) => {
    // e.preventDefault();

    try {

      const validateField = (value, setError, errorMessage) => {
        if (!value) {
          setError(errorMessage);
          return true;
        }
        setError("");
        return false;
      };

      let formDirty = false;

      formDirty = validateField(selectedCustomer, setBillToCustomerError, "Bill to customer is required") || formDirty;
      formDirty = validateField(selectedSupplier, setshipToCustomerError, "Ship to customer is required") || formDirty;
      // formDirty = validateField(selectedTransporter, settransporterError, "Transporter is required") || formDirty;
      formDirty = validateField(selectedPriceList, setpriceListError, "Price List is required") || formDirty;
      formDirty = validateField(dayjs(selectedDate), setindentdateError, "Order Date is required") || formDirty;
      formDirty = validateField(selectedPaymentTerm, setPaymentTermError, "Payment Terms is required") || formDirty;

      // check order data values

      if (rows.length > 0) {
        // ✅ check if all rows pass the condition
        const valid = rows.every(
          (row) => Number(row.UNITPRICE) > 0 && Number(row.BILLINGRATE) > 0
        );

        if (!valid) {
          setOpenAlert(true);
          showError('Please check unit price and billing rate values. unable to allow zero value.', 'warning');
          formDirty = true;
        }
      } else {
        setOpenAlert(true);
        showError('Please add product items to the order', 'warning');
        formDirty = true;
      }

      if (!formDirty) {
        if (rows.length === 0) {
          setOpenAlert(true);
          showError('Please add product items to the order', 'warning');
        }
        else {
          setOpenAlert(false);
          // setLoading(true);

          let valOrderID = 0;
          let valConfirmationID = 0;

          if (IndentId === '0') {
            valOrderID = orderID;
            valConfirmationID = confirmationID;
          }
          else {
            valOrderID = IndentId;
            valConfirmationID = ConfirmationOrderId;
          }
          const formattedDate = dayjs(selectedDate).format('YYYY-MMM-DD');

          const orderData = {
            SShipToCustomer: SShipToCustomer,
            SBillToCustomer: SBillToCustomer,
            STransporter: STransporter,
            SPriceList: Pricelistid,
            SRefNo: SRefNo,
            SRemarks: SRemarks,
            SIndentDate: formattedDate,
            SScheduledDate: scheduleDate,
            SSalesOrderItems: rows,
            SOrderId: valOrderID,
            SConfirmationId_API: valConfirmationID,
            SShipmentMode: Id_ShipmentMode,
            SPaymentTerm: Id_PaymentTerm,
            SCreditTerm: Id_CreditTerm,
            SCreditLimitRule: Id_CreditTermRule,
            // newly added 
            //SShipmentMode: selectedShipmentMode.codeId,
            PODate: dayjs(poDate).format('YYYY-MMM-DD'),
            Region: region,
            RegionDeliveryArea: regionDeliveryArea,
            SSalesOrderSummary: [totals]

          };

          const requestBody = {
            orderData: orderData,
            DocumentSeries: DocumentSeries,
            filter: {
              FinancierYear: FinancierYear,
              CompanyID: CompanyID,
            },
          };

          fetch(API_ENDPOINTS.saveOrderDetails, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
          })
            .then(response => {
              if (!response.ok) {
                throw new Error('Unable to save the order')
              }
              return response.json();
            })
            .then(data => {
              //console.log('new order created');
              SetSalesorderno(data.SIndentNo);
              setbtnSaveOrderText(data.btnText); //button text (ie., save,update)
              hideButton();
              setorderID(data.SOrderId);
              setconfirmationID(data.SConfirmationId_API);
              setOpenAlert(true);
              setAlertMessage(data.ReturnValidationMessage);
              setalertsevierity('success');
              showSnackbar();
              setheadervalueset('Update Order');
              setbtnCancel(true);
            })
            .catch(error => {
              showError('Unable to save the order.!', 'error');
            });
          closePopup();
        }
      }

      // setTimeout(() => {
      //   setLoading(false);
      // }, 3000);

    } catch (error) {
      // Handle any errors that occur during the API call
      //console.error('Error:', error);

    } finally {

      // Stop the progress bar, whether the API call is successful or not
      // setTimeout(() => {
      //   setLoading(false);
      // }, 3000);
    }

  };

  const validateField1 = (value, setError, errorMessage) => {
    if (!value) {
      setError(errorMessage);
      return true;
    }
    setError("");
    return false;
  };





  const handleApproveOrdersSubmit = async (e) => {
    e.preventDefault();


    let formDirty = false;
    formDirty = validateField1(selectedCustomer, setBillToCustomerError, "Bill to customer is required") || formDirty;
    formDirty = validateField1(selectedSupplier, setshipToCustomerError, "Ship to customer is required") || formDirty;
    // formDirty = validateField1(selectedTransporter, settransporterError, "Transporter is required") || formDirty;
    formDirty = validateField1(selectedPriceList, setpriceListError, "Price List is required") || formDirty;
    formDirty = validateField1(selectedDate, setindentdateError, "Order Date is required") || formDirty;
    formDirty = validateField1(selectedPaymentTerm, setPaymentTermError, "Payment Terms is required") || formDirty;

    if (!formDirty) {
      if (rows === '') {

        showError('Please add product items to the order', 'error');
      }
      else {

        // // ✅ Ask user confirmation before proceeding
        // const confirmed = window.confirm("Do you want to approve this order?");
        // if (!confirmed) {
        //   return; // 🚫 stop process if user clicks Cancel
        // }



        setOpenAlert(false);
        //setLoading(true);

        let valOrderID = 0;
        let valConfirmationID = 0;

        if (IndentId === '0') {
          valOrderID = orderID;
          valConfirmationID = confirmationID;
        }
        else {
          valOrderID = IndentId;
          valConfirmationID = ConfirmationOrderId;
        }

        const formattedDate = dayjs(selectedDate).format('YYYY-MMM-DD');
        const orderData = {
          SShipToCustomer: SShipToCustomer,
          SBillToCustomer: SBillToCustomer,
          STransporter: STransporter,
          SPriceList: Pricelistid,
          SRefNo: SRefNo,
          SRemarks: SRemarks,
          SIndentDate: formattedDate,
          SScheduledDate: scheduleDate,
          SSalesOrderItems: rows,  // Include the rows in SSalesOrderItems
          SShipmentMode: Id_ShipmentMode,
          SPaymentTerm: Id_PaymentTerm,
          SCreditTerm: Id_CreditTerm,
          SCreditLimitRule: Id_CreditTermRule,
          SOrderId: valOrderID,
          SConfirmationId_API: valConfirmationID,
          // newly added 
          PODate: dayjs(poDate).format('YYYY-MMM-DD'),
          Region: region,
          RegionDeliveryArea: regionDeliveryArea,
          SSalesOrderSummary: [totals]

        };

        const requestBody = {
          orderData: orderData,
          DocumentSeries: DocumentSeries,
          filter: {
            FinancierYear: FinancierYear,
            CompanyID: CompanyID,
          },
        };

        await callApi(API_ENDPOINTS.approveOrderDetails, 'POST', { 'Content-Type': 'application/json' }, requestBody)
          .then(data => {

            if (!data) {
              showError('No response received from server', 'error');
              return;
            }

            SetSalesorderno(data.SIndentNo);
            setbtnSaveOrderText(data.btnText);
            hideButton();
            setorderID(data.SOrderId);
            setconfirmationID(data.SConfirmationId_API);
            setOpenAlert(true);
            setAlertMessage(data.ReturnValidationMessage);
            setalertsevierity('info');
            showSnackbar();
            setbtnSaveUpdateOrdershow(false);
            setShow(false);
            setbtnAmendmentshow(true);
            setbtnAddProduct(false);
            setrowEditAndDelete(false);
            setbtnPrint(true);
            setbtnAdditionalDetailshow(false);
            setheadervalueset('Approved Order');
            setbtnCancel(true);
            setvisibleAmendmentReason(true);
            //setLoading(false);
          })
          .catch(error => {
            // CallMessage('error', error.message, 'Error'); 
            alert(error.message);
            //setLoading(false);
          });

        closePopup();

      }
    }

    // Close the dialog
    handleCloseApproveConfirmation();
  };




  const [alignment, setAlignment] = React.useState('left');

  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  const handleCloseApproveConfirmation = () => {
    setOpenApproveConfirmation(false);
  };

  const handleShowApproveConfirmation = () => {
    setOpenApproveConfirmation(true);
  };

  const handleShowCancelConfirmation = () => {
    setOpenCancelConfirmation(true);
  };

  const handleCloseCancelConfirmation = () => {
    setOpenCancelConfirmation(false);
  };

  const handleCloseAmendmentConfirmation = () => {
    setOpenAmendmentConfirmation(false);
  };

  const handleShowAmendmentConfirmation = () => {
    setOpenAmendmentConfirmation(true);
  };



  const columns = [
    {
      field: 'actions',
      headerName: '',
      width: 80,
      isFrozen: true,
      renderCell: (params) => (
        <span className="actions">
          {rowEditAndDelete &&

            <IconButton aria-label="edit" onClick={() => handleEditRow(params.row)}>
              <EditIcon sx={{ color: '#388e3c' }} />
            </IconButton>
          }

          {rowEditAndDelete &&

            <IconButton aria-label="delete" onClick={() => handleDeleteRow(params.row)}>
              <Closeicon sx={{ color: '#c75f6b' }} />
            </IconButton>
          }

          {rowEditAndDelete &&

            <IconButton aria-label="cancel" onClick={() => handleDeleteRow(params.row)}>
              <CancelIcon sx={{ color: '#6e5fc7ff' }} />
            </IconButton>
          }
        </span>
      ),
    },
    { field: 'SIVariety', headerName: 'VARIETY', sortable: false, pinned: 'left' },
    { field: 'SIGSM', headerName: 'GSM', pinned: 'left', fixed: true, width: 10 },
    { field: 'SIWidth', headerName: 'WIDTH (cm)', pinned: 'left', fixed: true, width: 80 },
    { field: 'SILength', headerName: 'LENGTH (cm)', pinned: 'left', fixed: true, width: 80 },
    { field: 'UNITTYPE', headerName: 'UNIT', fixed: true, width: 25 },
    { field: 'SIColor', headerName: 'COLOR', fixed: true, width: 25 },
    { field: 'SIGrainDirection', headerName: 'GRAIN', width: 10 },
    { field: 'PackageType', headerName: 'PACKAGE MODE' },
    { field: 'NOOFREELS', headerName: 'NO OF REELS' },
    { field: 'SIRequested_Qty', headerName: 'REQ.QTY (Kg)', width: 120 },
    { field: 'SIConfirmed_Qty', headerName: 'CONF.QTY. (Kg)', width: 120 },
    { field: 'SINoOfSheets', headerName: 'SHEETS', width: 10 },
    { field: 'SIReamWeight', headerName: 'REAM WEIGHT', width: 80 },
    { field: 'SIUnitPrice', headerName: 'UNIT PRICE', width: 70 },
    { field: 'BILLINGRATE', headerName: 'BILLING RATE', width: 70 },
    { field: 'SIDiscountType', headerName: 'DISCOUNT TYPE', width: 90 },
    { field: 'SIDiscount', headerName: 'DISCOUNT/UNIT', width: 90 },
    { field: 'SIReelCoreID', headerName: 'CORE ID(inches)', width: 90 },
    { field: 'SIReelOD', headerName: 'REEL OD(cm)', width: 90 },
    { field: 'OrderType', headerName: 'ORDER TYPE' },
    { field: 'SIRemarks', headerName: 'REMARKS' },
    { field: 'SISpecialInstruction', headerName: 'SPECIAL INSTRUCTION', width: 130 },
    { field: 'ItemStatus', headerName: 'STATUS' },
    { field: 'Deckle_Qty', headerName: 'DECKLE.QTY (Kg)', width: 120 },
    { field: 'Stock_Qty', headerName: 'STOCK.QTY (Kg)', width: 120 },
    { field: 'id', headerName: 'LINE NO', width: 50 },
  ];


  const handleChange = (e) => {
    const { name, value } = e.target;

    let newState = { ...formState, [name]: value };

    // Handle LENGTH changes
    if (name === "LENGTH") {
      if (parseFloat(value) === 0) {
        newState = { ...newState, NOOFSHEETS: 0 };
      } else {
        const no_of_sheets = defaultParameterConfig.find(e => e.p_name === "No of Sheets");
        newState = {
          ...newState,
          REELOD: 0,
          COREID: 0,
          NOOFSHEETS: no_of_sheets?.p_default_value ?? 0,
        };
        setSelectedcoreid({ CodeId: '0', Description: '0', "Country Name": null });
      }
    }

    // Reset REELOD if LENGTH exists
    if (name === "REELOD" && parseFloat(newState.LENGTH) > 0) {
      newState.REELOD = 0;
    }

    // Handle NOOFSHEETS logic
    if (name === "NOOFSHEETS") {
      newState.NOOFSHEETS = parseFloat(newState.LENGTH) === 0 ? 0 : value;
    }

    // Mirror RequestedQty to COQTY
    if (name === "RequestedQty") {
      newState.COQTY = value;
    }

    // Grain logic
    if (name === "WIDTH" || name === "LENGTH") {
      const width = parseFloat(newState.WIDTH || 0);
      const length = parseFloat(newState.LENGTH || 0);
      let grainValue = width > length ? "S" : width < length ? "L" : "B";
      if (length === 0) {
        grainValue = 'B';
      }
      const selectedGrain = datagrain.find(item => item.CodeId === grainValue);
      if (selectedGrain) {
        newState.GRAIN = grainValue;
        setSelectedgrain(selectedGrain);
      }
    }

    if (name === "RequestedQty" || name === "NOOFREELS") {
      setFormState(newState); // update formState
      CalculateOrderQtyBasedOnReel(name, newState); // pass freshly updated state
    } else {
      setFormState(newState);
    }


    // Optional: track user interaction
    setuserInteractedExistingItem(true);
  };

  const handleChange1 = (e) => {
    const { name, value } = e.target;



    let newState = { ...formState, [name]: value };

    if (name === "LENGTH") {
      if (parseFloat(value) === 0) {
        newState = { ...newState, NOOFSHEETS: 0 };
      } else {
        const no_of_sheets = defaultParameterConfig.find(e => e.p_name === "No of Sheets");
        newState = {
          ...newState,
          REELOD: 0,
          COREID: 0,
          NOOFSHEETS: no_of_sheets?.p_default_value ?? 0,
        };
        setSelectedcoreid({ CodeId: '0', Description: '0', "Country Name": null });
      }
    }

    if (name === "REELOD" && parseFloat(newState.LENGTH) > 0) {
      newState.REELOD = 0;
    }

    if (name === "NOOFSHEETS") {
      newState.NOOFSHEETS = parseFloat(newState.LENGTH) === 0 ? 0 : value;
    }

    if (name === "RequestedQty") {
      newState.COQTY = value;
    }

    // Grain logic
    if (name === "WIDTH" || name === "LENGTH") {
      const width = parseFloat(newState.WIDTH || 0);
      const length = parseFloat(newState.LENGTH || 0);
      let grainValue = width > length ? "S" : width < length ? "L" : "B";
      if (length === 0) {
        grainValue = 'B';
      }
      const selectedGrain = datagrain.find(item => item.CodeId === grainValue);
      if (selectedGrain) {
        newState.GRAIN = grainValue;
        setSelectedgrain(selectedGrain);
      }
    }

    setFormState(newState);
    setuserInteractedExistingItem(true);

  };


  const CalculateOrderQtyBasedOnReel = (triggerField, state) => {
    const Reel_Width = parseFloat(state.WIDTH) || 0;
    const Reel_od = parseFloat(state.REELOD) || 0;
    const Reel_unit = state.UNITTYPE;
    const Reel_uom = state.UnitOfMeasureCode;
    const Reel_count = parseFloat(state.NOOFREELS) || 0;
    const orderQty = parseFloat(state.RequestedQty) || 0;

    let tSingleReelWeightInKg = 0;

    if (
      Reel_Width > 0 &&
      Reel_od > 0 &&
      weightPerCMInKg > 0 &&
      weightPerInchInKg > 0
    ) {
      const tmpWeightPerCMInKg = (weightPerCMInKg * Reel_od) / 100;
      const tmpWeightPerMMInKg = (weightPerCMInKg * Reel_od) / 1000;
      const tmpWeightPerInchInKg = (weightPerInchInKg * Reel_od) / 100;

      if (Reel_unit?.toLowerCase() === "cm") {
        tSingleReelWeightInKg = tmpWeightPerCMInKg * Reel_Width;
      } else if (Reel_unit?.toLowerCase() === "mm") {
        tSingleReelWeightInKg = tmpWeightPerMMInKg * Reel_Width;
      } else if (["inch", "inches"].includes(Reel_unit?.toLowerCase())) {
        tSingleReelWeightInKg = tmpWeightPerInchInKg * Reel_Width;
      }

      if (Reel_uom?.toLowerCase() === "mt") {
        tSingleReelWeightInKg /= 1000;
      }

      if (triggerField === "NOOFREELS" && Reel_count > 0) {
        const calculatedQty = Number((tSingleReelWeightInKg * Reel_count).toFixed(2));
        setFormState(prev => ({
          ...prev,
          RequestedQty: calculatedQty,
          COQTY: calculatedQty,
        }));
      } else if (triggerField === "RequestedQty" && orderQty > 0 && tSingleReelWeightInKg > 0) {
        const calculatedReels = Math.ceil(orderQty / tSingleReelWeightInKg);
        setFormState(prev => ({
          ...prev,
          NOOFREELS: calculatedReels,
        }));
      }
    }
  };


  const CalculateOrderQtyBasedOnReel2 = () => {
    let Reel_Width = parseFloat(formState.WIDTH) || 0;
    let Reel_length = parseFloat(formState.LENGTH) || 0;
    let Reel_count = parseFloat(formState.NOOFREELS) || 0;
    let Reel_od = parseFloat(formState.REELOD) || 0;
    let Reel_unit = formState.UNITTYPE;
    let Reel_uom = formState.UnitOfMeasureCode;

    let tSingleReelWeightInKg = 0;

    // Ensure all required values are valid
    if (
      Reel_Width > 0 &&
      Reel_od > 0 &&
      weightPerCMInKg > 0 &&
      weightPerInchInKg > 0
    ) {
      const tmpWeightPerCMInKg = (weightPerCMInKg * Reel_od) / 100;
      const tmpWeightPerMMInKg = (weightPerCMInKg * Reel_od) / 1000;
      const tmpWeightPerInchInKg = (weightPerInchInKg * Reel_od) / 100;

      // Calculate weight per reel depending on the unit
      if (Reel_unit.toLowerCase() === "cm") {
        tSingleReelWeightInKg = tmpWeightPerCMInKg * Reel_Width;
      } else if (Reel_unit.toLowerCase() === "mm") {
        tSingleReelWeightInKg = tmpWeightPerMMInKg * Reel_Width;
      } else if (Reel_unit.toLowerCase() === "inch" || Reel_unit.toLowerCase() === "inches") {
        tSingleReelWeightInKg = tmpWeightPerInchInKg * Reel_Width;
      }

      // Adjust for UOM (e.g., meters)
      if (Reel_uom && Reel_uom.toLowerCase() === "mt") {
        tSingleReelWeightInKg = tSingleReelWeightInKg / 1000; // Convert to meters
      }

      // If COQTY (Order Quantity) is provided, calculate the number of reels and reset the other
      if (formState.COQTY > 0) {
        const tOrderQty = parseFloat(formState.COQTY) || 0;
        // Calculate the number of reels, ensuring it's an integer
        const calculatedReels = Math.ceil(tOrderQty / tSingleReelWeightInKg); // Round up to nearest integer

        // Update the state with calculated number of reels and set other values to 0
        setFormState(prevState => ({
          ...prevState,
          NOOFREELS: calculatedReels,
          RequestedQty: tOrderQty,
          COQTY: tOrderQty, // Set COQTY to the provided order qty
        }));
      }
      // If Reel_count is provided, calculate COQTY (Order Quantity) and reset the other
      else if (Reel_count > 0) {
        const tOrderQty = Number((tSingleReelWeightInKg * Reel_count).toFixed(2));

        // Update the state with calculated COQTY and set other values to 0
        setFormState(prevState => ({
          ...prevState,
          RequestedQty: tOrderQty,
          COQTY: tOrderQty, // Set COQTY to the calculated order qty
          NOOFREELS: Reel_count, // Keep the provided Reel count
        }));
      }
    }
  };


  const CalculateOrderQtyBasedOnReel1 = () => {
    let Reel_Width = parseFloat(formState.WIDTH) || 0;
    let Reel_length = parseFloat(formState.LENGTH) || 0;
    let Reel_count = parseFloat(formState.NOOFREELS) || 0;
    let Reel_od = parseFloat(formState.REELOD) || 0;
    let Reel_unit = formState.UNITTYPE;
    let Reel_uom = formState.UnitOfMeasureCode;

    if (
      Reel_count > 0 &&
      Reel_Width > 0 &&
      Reel_od > 0 &&
      weightPerCMInKg > 0 &&
      weightPerInchInKg > 0
    ) {
      const tmpWeightPerCMInKg = (weightPerCMInKg * Reel_od) / 100;
      const tmpWeightPerMMInKg = (weightPerCMInKg * Reel_od) / 1000;
      const tmpWeightPerInchInKg = (weightPerInchInKg * Reel_od) / 100;

      let tSingleReelWeightInKg = 0;

      if (Reel_unit.toLowerCase() === "cm") {
        tSingleReelWeightInKg = tmpWeightPerCMInKg * Reel_Width;
      } else if (Reel_unit.toLowerCase() === "mm") {
        tSingleReelWeightInKg = tmpWeightPerMMInKg * Reel_Width;
      } else if (Reel_unit.toLowerCase() === "inch" || Reel_unit.toLowerCase() === "inches") {
        tSingleReelWeightInKg = tmpWeightPerInchInKg * Reel_Width;
      }

      if (Reel_uom !== undefined) {
        if (Reel_uom.toLowerCase() === "mt") {
          tSingleReelWeightInKg = tSingleReelWeightInKg / 1000;
        }
      }


      const tOrderQty = Number((tSingleReelWeightInKg * Reel_count).toFixed(2));



      if (Reel_count !== 0) {
        // If LENGTH is 0, set NOOFSHEETS to 0
        setFormState(prevState => ({
          ...prevState,
          RequestedQty: tOrderQty,
          COQTY: tOrderQty,

        }));
      }
      //return tOrderQty;
    }




  }


  const fetchDataEdit = async (masterGroup, filterCode) => {
    const commonParams = {
      FinancierYear,
      masterGroup,
      filterCode,
      CompanyID: localStorage.getItem('companyid')
    };

    try {
      const response = await fetch(API_ENDPOINTS.GET_MASTER_LIST_BY_CODE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(commonParams)
      });

      if (!response.ok) {
        throw new Error(`Unable to fetch data for ${masterGroup}`);
      }

      const data = await response.json();
      return data; // ✅ this is now returned to caller
    } catch (error) {
      setAlertMessage(`Unable to fetch data for ${masterGroup}`);
      setalertsevierity('error');
      showSnackbar();
      return []; // safe fallback instead of undefined
    }
  };





  const fetchData = async (masterGroup, filterCode, setOptionsCallback) => {
    const commonParams = {
      FinancierYear,
      masterGroup,
      filterCode,
      CompanyID: localStorage.getItem('companyid')
    };

    await fetch(API_ENDPOINTS.GET_MASTER_LIST_BY_CODE, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(commonParams)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Unable to fetch data for ${masterGroup}`);
        }
        return response.json();
      })
      .then(data => {
        setOptionsCallback(data);
        return data;
      })
      .catch(error => {
        setAlertMessage(`Unable to fetch data for ${masterGroup}`);
        setalertsevierity('error');
        showSnackbar();
      });
  };

  const handleSelectProductgroup = (event, newValue) => {
    if (newValue !== undefined && newValue !== null) {
      setSelectedProductgroup(newValue);
      setFormState(prevState => ({
        ...prevState,
        ProductGroupID: newValue.CodeId,
      }));
      // fetchData('PRODUCT_SUBGROUP', newValue.CodeId, setOptionsProductSubgroup);
      setSelectedProductsubgroup('');
      debouncedFetchData('PRODUCT_SUBGROUP', newValue.CodeId, setOptionsProductSubgroup);
      setSelectedProductsubgroup('');
    }
  };

  const debouncedFetchData = useCallback(
    debounce((masterGroup, filterCode, setOptionsCallback) => {
      // setLoading(true);
      fetchData(masterGroup, filterCode, setOptionsCallback);
    }, 2), [] // Adjust the debounce time as needed
  );

  const handleSelectProductsubgroup = (event, newValue) => {
    if (newValue !== undefined && newValue !== null) {
      setSelectedProductsubgroup(newValue);
      setFormState(prevState => ({
        ...prevState,
        ProductSubGroupID: newValue.CodeId,
      }));
      fetchData('PRODUCT_VARIETY', newValue.CodeId, setOptionsVariety);
    }
  };

  const handleSelectvariety = (event, newValue) => {
    if (newValue !== undefined && newValue !== null) {
      setSelectedvariety(newValue);
      setFormState(prevState => ({
        ...prevState,
        VARIETY: newValue.Description,
        ProductVarietyID: newValue.CodeId,
      }));
    }
  };

  const handleSelectgrade = (event, newValue) => {
    if (newValue !== undefined && newValue !== null) {
      setSelectedgrade(newValue);
      setFormState(prevState => ({
        ...prevState,
        GRADE: newValue.CodeId,
      }));
      setUserInteracted(true);
    }
  };

  const handleSelectHsn = (event, newValue) => {
    if (newValue !== undefined && newValue !== null) {
      setSelectedhsn(newValue);
      setFormState(prevState => ({
        ...prevState,
        HSNCode: newValue.hsncode,
        CGSTPERSENTAGE: newValue.cgstpercent,
        SGSTPERSENTAGE: newValue.sgstpercent,
        IGSTPERSENTAGE: newValue.igstpercent,
      }));
      setUserInteracted(true);
    }
    else {
      setSelectedhsn('');
      setFormState(prevState => ({
        ...prevState,
        HSNCode: '',
        CGSTPERSENTAGE: 0,
        SGSTPERSENTAGE: 0,
        IGSTPERSENTAGE: 0,
      }));
    }
  };

  const handleSelectgrain = (event, newValue) => {
    if (newValue !== undefined && newValue !== null) {
      setSelectedgrain(newValue);
      setFormState(prevState => ({
        ...prevState,
        GRAIN: newValue.Description,
      }));
    }
  };

  const handleSelectUnit = (event, newValue) => {
    if (newValue !== undefined && newValue !== null) {
      setSelectedUnit(newValue);
      setFormState(prevState => ({
        ...prevState,
        UNITID: newValue.CodeId,
        UNITTYPE: newValue.Description,
      }));
    }
  };

  const handleSelectcoreid = (event, newValue) => {
    if (newValue !== undefined && newValue !== null) {
      if (parseFloat(formState.LENGTH) === 0) {
        setSelectedcoreid(newValue);
        setFormState(prevState => ({
          ...prevState,
          COREID: newValue.Description,

        }));
      }
    }
  };



  const handleSelectremarks = (newValue) => {
    if (newValue !== undefined && newValue !== null) {
      let valueObj;

      if (typeof newValue === "string") {
        // user typed custom text
        valueObj = { Description: newValue };
      } else if (newValue && newValue.Description) {
        // user selected from options
        valueObj = newValue;
      } else {
        valueObj = null;
      }

      setSelectedremarks(valueObj);
      setFormState((prevState) => ({
        ...prevState,
        REMARKS: valueObj ? valueObj.Description : "",
      }));
    } else {
      // cleared
      setSelectedremarks(null);
      setFormState((prevState) => ({
        ...prevState,
        REMARKS: "",
      }));
    }
  };

  const handleSelectDiscountType = (event, newValue) => {
    if (newValue !== undefined && newValue !== null) {
      setselectedDiscountType(newValue);
      setFormState(prevState => ({
        ...prevState,
        DiscountType: newValue.Description,
      }));
    }
  };

  const handleSelectOrderType = (event, newValue) => {
    if (newValue !== undefined && newValue !== null) {
      setselectedOrderType(newValue);
      setFormState(prevState => ({
        ...prevState,
        OrderType: newValue.Description,
      }));
      setUserInteracted(true);
    }
  };

  const handleSelectPackageType = (event, newValue) => {
    if (newValue !== undefined && newValue !== null) {
      setselectedPackageType(newValue);
      setFormState(prevState => ({
        ...prevState,
        PackageType: newValue.Description,
        PackageID: newValue.CodeId,
      }));

    }
  };

  useEffect(() => {
    const fetchMasterData = async () => {
      try {
        const requests = [
          { group: 'SO_CREDIT_LIMIT_RULE', setter: setdataCredittermRule, msg: 'Credit term rule details not found' },
          { group: 'SO_CREDIT_TERM', setter: setdataCreditterm, msg: 'Credit term details not found' },
          { group: 'SO_PAYMENT_TERM', setter: setdataPaymentterm, msg: 'Payment term details not found' },
          { group: 'SO_SHIPMENT_MODE', setter: setdataShipmentmode, msg: 'Shipment mode details not found' },
          { group: 'SO_CUSTOMER', setter: setdataSupplier, msg: 'Customer details not found' },
          { group: 'SO_CUSTOMER', setter: setdataCustomer, msg: 'Supplier details not found' },
          { group: 'PRODUCT_GROUP', setter: setdataProductgroup, msg: 'Product group not found' },
          { group: 'ITEM_GRADE', setter: setdataGrade, msg: 'Product grade not found', endpoint: API_ENDPOINTS.GET_MASTER_LIST_BY_CODE, extra: { filterCode: 'Select Grade' } },
          { group: 'ITEM_GRAIN', setter: setdatagrain, msg: 'Product grain list not found' },
          { group: 'ITEM_UNIT', setter: setdataUnitType, msg: 'Product Unit list not found', endpoint: API_ENDPOINTS.GET_MASTER_LIST_BY_CODE, extra: { filterCode: 'Select Unit' } },
          { group: 'ITEM_REELCOREID', setter: setdataCoreID, msg: 'Product core id not found' },
          { group: 'PACKAGE_TYPE', setter: setdataRemarks, msg: 'Product remarks not found' },
          { group: 'DISCOUNT_TYPE', setter: setdataDiscountType, msg: 'Product discount not found' },
          { group: 'ITEM_ORDERTYPE', setter: setdataOrderType, msg: 'Product order type not found' },
          { group: 'PACKAGE_MODE', setter: setdataPackageType, msg: 'Product package type not found', endpoint: API_ENDPOINTS.GET_MASTER_LIST_BY_CODE, extra: { filterCode: 'Select Package mode' } }
        ];

        await Promise.all(
          requests.map(req =>
            loadMasterData(
              req.endpoint || API_ENDPOINTS.GET_MASTER_LIST,
              { ...commonParams, masterGroup: req.group, ...(req.extra || {}) },
              req.setter,
              req.msg
            )
          )
        );
      } catch (error) {
        console.error("Failed to load master data:", error);
      }
    };

    fetchMasterData();
  }, []); // <-- Empty array so it runs only once




  const getDefaultFormValues = (rowToEdit) => {
    const company = parseInt(localStorage.getItem('companyid') ?? '0', 10);
    // Default template
    const defaultValues = {
      id: 0,
      ProductGroupID: 0,
      ProductSubGroupID: 0,
      ProductVarietyID: 0,
      Code: "",
      AuthorisedForSaleFlag: "True",
      Color: "white",
      GRADE: "P",
      GSM: 0,
      BF: 0,
      WIDTH: 0,
      LENGTH: 0,
      Thickness: 0,
      MinLevel: 0,
      MaxLevel: 0,
      OpeningQty: 0,
      OpeningQtyValue: 0,
      ReOrderLevel: 0,
      ShelfLifeDays: 0,
      unit: "cm",
      UnitOfMeasureCode: "Kg",
      HSNCode: '',
      DiscountFlag: "True",
      AllowNegativeInventoryFlag: "False",
      DiscountType: "",
      DiscountRate: 0,
      TaxInclusiveSalePrice: 0,
      TaxExemptedFlag: "True",
      MinimumSaleQty: 0,
      MaximumSaleQty: 0,
      RequestedQty: 0,
      UNITPRICE: 0,
      BILLINGRATE: 0,
      VARIETY: "",
      GRAIN: "",
      REELOD: 0,
      COREID: 0,
      NOOFSHEETS: 0,
      ReamWeight: 0,
      ORDERQTY: 0,
      COQTY: 0,
      REMARKS: "",
      SPECIAL_INSTRUCTION: "",
      OrderType: "",
      STATUS: "",
      PriceListId: "",
      SProductID: 0,
      SICode: "",
      SIVariety: "",
      SIGSM: 0,
      SIWidth: 0,
      SILength: 0,
      SIColor: "",
      SIGrainDirection: "",
      SIPackageMode: "",
      SIRequested_Qty: 0,
      SIConfirmed_Qty: 0,
      SINoOfSheets: 0,
      SIReamWeight: 0,
      SIUnitPrice: 0,
      SIDiscountType: "",
      SIDiscount: 0,
      SIReelCoreID: 0,
      SIReelOD: 0,
      SIRemarks: "",
      SISpecialInstruction: "",
      SIOrderType: "",
      DMStatus: "New",
      companyid: company,
      PackageType: '',
      PackageID: 0,
      UNITID: 1,
      UNITTYPE: 'Inch',
      SIUnit: 'Kg',
      Deckle_Qty: 0,
      Stock_Qty: 0,
      SIActualPrice: 0,
      CGSTPERSENTAGE: 0,
      SGSTPERSENTAGE: 0,
      IGSTPERSENTAGE: 0,
      ItemStatus: 'New'
    };

    // Merge: rowToEdit values overwrite defaults, but ensure companyid is set
    return {
      ...defaultValues,
      ...rowToEdit,
      companyid: rowToEdit?.companyid ?? company,
    };
  };
  const [formState, setFormState] = useState(initialValues());
  //getDefaultFormValues(rowToEdit)

  useEffect(() => {

    //While New product Add//

    //Product Sub Group default value
    if (userInteracted === false) {
      //default value Grage
      if (dataGrade.length > 0) {
        const selectedGrade = dataGrade.find(item => item !== '');
        if (selectedGrade) {
          setSelectedgrade(selectedGrade);
          setFormState(prevState => ({
            ...prevState,
            GRADE: selectedGrade.CodeId,
          }));
        }
      }

      if (dataHsn.length > 0) {
        // const selectedHsn = dataHsn.find(item => item !== '');
        // if (selectedHsn) {
        //   setSelectedhsn(selectedHsn);
        //   setFormState(prevState => ({
        //     ...prevState,
        //     HSNCode: selectedHsn.hsncode,
        //     CGSTPERSENTAGE: selectedHsn.cgstpercent,
        //     SGSTPERSENTAGE: selectedHsn.sgstpercent,
        //     IGSTPERSENTAGE: selectedHsn.igstpercent,
        //   }));
        // }
      }

      if (dataOrderType.length > 0) {
        const selectedOrderType = dataOrderType.find(item => item !== '');
        if (selectedOrderType) {
          setselectedOrderType(selectedOrderType);
        }
      }


      if (formState.RequestedQty > 0 && formState.COQTY <= 0) {
        setFormState(prevState => ({
          ...prevState,
          COQTY: formState.RequestedQty,
        }));
      }
      // setUserInteracted(true);
    }

    if (dataProductgroup.length > 0 && dataProductgroup.length <= 1) {
      setSelectedProductgroup(dataProductgroup[0]);
      setFormState(prevState => ({
        ...prevState,
        ProductGroupID: dataProductgroup[0].CodeId,
      }));
      fetchData('PRODUCT_SUBGROUP', optionsProductSubgroup[0].CodeId, setOptionsProductSubgroup);
    }

    //If sub group only single value set as default value.//
    if (optionsProductSubgroup.length > 0 && optionsProductSubgroup.length <= 1) {
      setSelectedProductsubgroup(optionsProductSubgroup[0]);
      setFormState(prevState => ({
        ...prevState,
        ProductSubGroupID: optionsProductSubgroup[0].CodeId,
      }));
      fetchData('PRODUCT_VARIETY', optionsProductSubgroup[0].CodeId, setOptionsVariety);

    }
    else {
      setSelectedProductsubgroup('');
    }


    //Exiting Items
    if (rowToEdit != null && userInteractedExistingItem === false) { //
      SetpageTitle('Update Product Detail');
      formState.WIDTH = rowToEdit.SIWidth;
      formState.LENGTH = rowToEdit.SILength;
      formState.REELOD = rowToEdit.SIReelOD;
      formState.COREID = rowToEdit.SIReelCoreID;
      formState.NOOFSHEETS = rowToEdit.SINoOfSheets;
      formState.RequestedQty = rowToEdit.SIRequested_Qty;
      formState.COQTY = rowToEdit.SIConfirmed_Qty;
      formState.UNITPRICE = rowToEdit.SIUnitPrice;
      formState.SPECIAL_INSTRUCTION = rowToEdit.SISpecialInstruction;
      formState.GSM = rowToEdit.SIGSM
      formState.SProductID = rowToEdit.SProductID;
      formState.SICode = rowToEdit.SICode;

      if (dataProductgroup.length > 0) {
        const codeIdValue = rowToEdit.ProductGroupID;
        const stringCodeIdValue = String(codeIdValue);
        const filteredData = dataProductgroup.filter((item) => item.CodeId === stringCodeIdValue);

        if (filteredData.length > 0) {
          setSelectedProductgroup(filteredData[0]);
          handleSelectProductgroup(0, filteredData[0])
        }
      }

      if (optionsProductSubgroup.length > 0) {
        const codeIdValue = rowToEdit.ProductSubGroupID;
        const stringCodeIdValue = String(codeIdValue);
        const filteredData = optionsProductSubgroup.filter((item) => item.CodeId === stringCodeIdValue);

        if (filteredData.length > 0) {
          setSelectedProductsubgroup(filteredData[0]);
          handleSelectProductsubgroup(0, filteredData[0])
        }
      }

      if (optionsVariety.length > 0) {
        const codeIdValue = rowToEdit.ProductVarietyID;
        const stringCodeIdValue = String(codeIdValue);
        const filteredData = optionsVariety.filter((item) => item.CodeId === stringCodeIdValue);

        if (filteredData.length > 0) {
          setSelectedvariety(filteredData[0]);
          setFormState(prevState => ({
            ...prevState,
            VARIETY: filteredData[0].Description,
            ProductVarietyID: filteredData[0].CodeId,
          }));
        }
      }
    }

    setDisabledReelOD(false);
    setDisabledCoreID(false);
    setDisabledNoofSheets(false);
  });








  const [isDuplicate, setIsDuplicate] = useState(false);

  const validateField = (field, errorSetter, errorMessage) => {
    if (!formState[field] || !formState[field].length || formState[field] === 0) {
      errorSetter(errorMessage);
      return true;
    }
    errorSetter("");
    return false;
  };



  const validateNumberField = (field, errorSetter, errorMessage) => {
    const value = formState[field];

    // convert to number safely
    const num = Number(value);

    // check if invalid (0, "0", "00", "", null, undefined, NaN)
    if (!value || isNaN(num) || num === 0) {
      errorSetter(errorMessage);
      return true; // has error
    }

    errorSetter("");
    return false; // no error
  };


  const handleProductSubmit = (e) => {
    e.preventDefault();
    formState.PriceListId = Pricelistid;

    let formDirty = false;

    if (isDuplicate) {
      alert('Duplicate row. Please enter a unique row.');
      return;
    }

    setNoOfSheetsError('');
    setReelODError('');
    setCoreIDError('');

    formDirty = validateNumberField("WIDTH", setWidthError, "Width is required") || formDirty;
    formDirty = validateField("GRADE", setGradeError, "Grade is required") || formDirty;
    formDirty = validateNumberField("RequestedQty", setRequiredQtyError, "Order Qty is required") || formDirty;
    formDirty = validateNumberField("COQTY", setCOQtyError, "CO Qty is required") || formDirty;
    formDirty = validateNumberField("UNITPRICE", setUnitpriceError, "Unit Price is required") || formDirty;
    formDirty = validateNumberField("BILLINGRATE", setBillingRateError, "Billing Rate is required") || formDirty;
    formDirty = validateField("PackageType", setPackageTypeError, "Package Typeis required") || formDirty;
    formDirty = validateNumberField("HSNCode", setHSNError, "HSN Code Typeis required") || formDirty;

    if (parseInt(formState["LENGTH"]) > 0) {
      formDirty = validateNumberField("NOOFSHEETS", setNoOfSheetsError, "No Of Sheets is required") || formDirty;

    }

    if (parseInt(formState["LENGTH"]) === 0) {
      formDirty = validateNumberField("REELOD", setReelODError, "REEL OD is required") || formDirty;
      formDirty = validateNumberField("COREID", setCoreIDError, "CORE ID is required") || formDirty;
    }


    formDirty = validateNumberField("ProductGroupID", setProductGroupError, "Product Group is required") || formDirty;
    formDirty = validateNumberField("ProductSubGroupID", setProductSubGroupError, "Product Sub Group is required") || formDirty;
    formDirty = validateNumberField("ProductVarietyID", setProductVarietyError, "Product Variety is required") || formDirty;


    if (formState.GRADE !== '') {
      if (selectedgrade.Allowgsmentry) {
        // Allow gsm entry
        formDirty = validateNumberField("GSM", setGSMError, "GSM is required") || formDirty;

      }
    }
    //CalculateNoOfSheets();
    calculateNoOfSheets(formState, setAlertMessage, setalertsevierity, showSnackbar);

    if (formState.thickness === null) {
      formState.thickness = 0;
    }

    if (!formDirty) {
      if (formState.SProductID === 0) {
        fetch(API_ENDPOINTS.getProductDetails, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formState)
        })
          .then(response => {
            if (!response.ok) {
              throw new Error('Unable to add product item in the order');
            }
            return response.json();
          })
          .then(data => {
            //console.log('new product created');

            data.SIUnitPrice = formState.UNITPRICE;
            data.SIRequested_Qty = formState.RequestedQty;
            data.SIConfirmed_Qty = formState.COQTY;
            data.SIReelOD = formState.REELOD;
            data.SIReelCoreID = formState.COREID;
            data.SINoOfSheets = formState.NOOFSHEETS;
            data.SIRemarks = formState.REMARKS;
            data.SISpecialInstruction = formState.SPECIAL_INSTRUCTION;
            data.SIDiscountType = formState.DiscountType;
            data.SIDiscount = formState.DiscountRate;
            data.SIOrderType = formState.OrderType;
            data.SIReamWeight = formState.ReamWeight;
            data.SIActualPrice = formState.BILLINGRATE;

            formState.SProductID = data.SProductID;
            formState.SICode = data.SICode;
            formState.SIVariety = data.SIVariety;
            formState.SIGSM = data.SIGSM;
            formState.SIWidth = data.SIWidth;
            formState.SILength = data.SILength;
            formState.SIColor = data.SIColor;
            formState.SIGrainDirection = data.SIGrainDirection;
            formState.SIPackageMode = data.SIPackageMode;
            formState.SIRequested_Qty = data.SIRequested_Qty;
            formState.SIConfirmed_Qty = data.SIConfirmed_Qty;
            formState.SINoOfSheets = data.SINoOfSheets;
            formState.SIReamWeight = data.SIReamWeight;
            formState.SIUnitPrice = data.SIUnitPrice;

            formState.SIDiscountType = data.SIDiscountType;
            formState.SIDiscount = data.SIDiscount;
            formState.SIReelCoreID = data.SIReelCoreID;
            formState.SIReelOD = data.SIReelOD;
            formState.SIRemarks = data.SIRemarks;
            formState.SISpecialInstruction = data.SISpecialInstruction;
            //formState.DMStatus = data.DMStatus;
            formState.SIOrderType = data.SIOrderType;
            formState.SIActualPrice = data.SIActualPrice;

            handleSubmit(formState);
            // closePopup();        

            setAlertMessage('Product items added in the order..!');
            setalertsevierity('success');
            showSnackbar();
          })
          .catch(error => {
            setAlertMessage('Unable to add product items in the order..!');
            setalertsevierity('error');
            showSnackbar();
          }, []);
      }
      else {
        try {
          //formState.SProductID = formState.SProductID;
          //formState.SICode = formState.SICode;
          formState.SIVariety = formState.VARIETY;
          formState.SIGSM = formState.GSM;
          formState.SIWidth = formState.WIDTH;
          formState.SILength = formState.LENGTH;
          formState.SIColor = formState.Color;
          formState.SIGrainDirection = formState.GRADE;
          // formState.SIPackageMode = formState.Pack;
          formState.SIRequested_Qty = formState.RequestedQty;
          formState.SIConfirmed_Qty = formState.COQTY;
          formState.SINoOfSheets = formState.NOOFSHEETS;
          formState.SIReamWeight = formState.ReamWeight;
          formState.SIUnitPrice = formState.UNITPRICE;
          formState.SIDiscountType = formState.DiscountType;
          formState.SIDiscount = formState.DiscountRate;
          formState.SIReelCoreID = formState.REELOD;
          formState.SIReelOD = formState.COREID;
          formState.SIRemarks = formState.REMARKS;
          formState.SISpecialInstruction = formState.SPECIAL_INSTRUCTION;
          // formState.DMStatus = rowToEdit.ItemStatus;
          formState.SIOrderType = formState.OrderType;
          handleSubmit(formState);
          closePopup();
        } catch (error) {
          setAlertMessage('Unable to add product items in the order..!');
          setalertsevierity('error');
          showSnackbar();
        }
      }
    }
  };




  const progressStyles = {
    "& .MuiLinearProgress-barColorPrimary": { backgroundColor: "#4CAF50" },
    "& .MuiLinearProgress-bar2Buffer": { backgroundColor: "#8BC34A" },
  };






  useEffect(() => {
    if (!isPaymentTermsLoaded) {
      fetchPaymentTerms();
    }
  }, [isPaymentTermsLoaded]);


  const fetchPaymentTerms = async () => {

    const para = {
      p_companyid: localStorage.getItem('companyid'),
      p_plantid: 1,
      p_mode: 1,
    }
    callApi(API_ENDPOINTS.PURCHASE_MANAGEMENT_GET_PAYMENT_TERMS, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {
        if (data && data.length > 0) {
          // Update state with fetched data
          setPaymentTerms(data);
          setIsPaymentTermsLoaded(true);
        }
      })
      .catch(error => {
        // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue(error.message);
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
        // 

      });
  };


  const leftOffsets = React.useMemo(() => {
    let offset = 0;
    return columns.map((col) => {
      if (col.pinned === 'left') {
        const current = offset;
        offset += (col.width || 100);
        return current;
      }
      return null;
    });
  }, [columns]);



  // Called when user changes summary values (UI input)
  const handleSummaryChange = (name, value) => {
    const numVal = parseFloat(value) || 0;

    if (name === "serviceChargePct") {
      setServiceCharge(numVal);
    } else if (name === "freightAmountPerMT") {
      setFrieightPerMT(numVal);
    } else if (name === "insuranceRatePct") {
      setInsurance(numVal);
    }
  };




  const initialForForm = useMemo(() => {
    if (mode === 'add') return initialValues();
    const base = initialValues();
    return {
      ...base,
      ...(current ?? {}),
      companyid: parseInt(localStorage.getItem('companyid') ?? '0', 10),
    };
  }, [mode, current]);



  const openAdd = () => {
    if (!selectedPriceList) {
      setOpenAlert?.(true);
      showError?.('Please select a price list before adding items.', 'warning');
      return;
    }

    refreshdata();
    setFormState(initialValues);
    handleLoadDefaultValues();
    setMode('add');
    setCurrent(null);
    SetpageTitle('Add Product Detail');
    setOpen(true);
  };



  const handleLoadDefaultValues = () => {
    // grade
    if (defaultValues.GRADE !== undefined && defaultValues.GRADE !== null && defaultValues.GRADE !== '') {
      const selectGroup = dataGrade.find(g => g.Description === defaultValues.GRADE);
      if (!selectGroup) {
        alert('grade issue');
      }
      setSelectedgrade(selectGroup);
      setFormState(prevState => ({
        ...prevState,
        GRADE: selectGroup.CodeId,
      }));
    }

    // core id
    if (defaultValues.COREID !== undefined && defaultValues.COREID !== null) {
      const selectGroup = dataCoreID.find(g => parseInt(g.CodeId) === parseInt(defaultValues.COREID));
      if (!selectGroup) {
        alert('coreid issue');
      }
      setSelectedcoreid(selectGroup);
      setFormState(prevState => ({
        ...prevState,
        COREID: selectGroup.CodeId,
      }));
    }

    // unit
    if (defaultValues.UNITID !== undefined && defaultValues.UNITID !== null && defaultValues.UNITID !== '') {
      const selectGroup = dataUnitType.find(g => g.Description === defaultValues.UNITID);
      if (!selectGroup) {
        alert('Unit issue');
      }
      setSelectedUnit(selectGroup);
      setFormState(prevState => ({
        ...prevState,
        UNITID: selectGroup.CodeID,
        UNITTYPE: selectGroup.Description,
      }));
    }

    // grain
    if (defaultValues.GRAIN !== undefined && defaultValues.GRAIN !== null && defaultValues.GRAIN !== '') {
      const selectGroup = datagrain.find(g => g.CodeId === defaultValues.GRAIN);
      if (!selectGroup) {
        alert('Unit issue');
      }
      setSelectedgrain(selectGroup);
      setFormState(prevState => ({
        ...prevState,
        GRAIN: selectGroup.CodeID,

      }));
    }

    // disount type
    if (defaultValues.DiscountType !== undefined && defaultValues.DiscountType !== null && defaultValues.DiscountType !== '') {
      const selectGroup = dataDiscountType.find(g => g.CodeId === defaultValues.DiscountType);
      if (!selectGroup) {
        alert('DiscountType issue');
      }
      setselectedDiscountType(selectGroup);
      setFormState(prevState => ({
        ...prevState,
        DiscountType: selectGroup.CodeId,
      }));
    }

    // order type
    if (defaultValues.OrderType !== undefined && defaultValues.OrderType !== null && defaultValues.OrderType !== '') {
      const selectGroup = dataOrderType.find(g => g.CodeId === defaultValues.OrderType);
      if (!selectGroup) {
        alert('Order Type issue');
      }
      setselectedOrderType(selectGroup);
      setFormState(prevState => ({
        ...prevState,
        OrderType: selectGroup.CodeId,
      }));
    }

    if (defaultValues.PackageType !== undefined && defaultValues.PackageType !== null && defaultValues.PackageType !== '') {
      const selectGroup = dataPackageType.find(g => g.Description === defaultValues.PackageType);
      if (!selectGroup) {
        alert('Order Type issue');
      }
      setselectedPackageType(selectGroup);
      setFormState(prevState => ({
        ...prevState,
        PackageType: selectGroup.Description,
        PackageID: selectGroup.CodeId,
      }));
    }

    // NOOFSHEETS
    if (defaultValues.NOOFSHEETS !== undefined && defaultValues.NOOFSHEETS !== null && defaultValues.NOOFSHEETS !== '') {
      setFormState(prevState => ({
        ...prevState,

        UNITPRICE: defaultValues.UNITPRICE,
      }));
    }

  }

  const refreshdata = async () => {
    setSelectedProductgroup('');
    setSelectedProductsubgroup('');
    setSelectedvariety('');
    setSelectedgrade('');
    setSelectedhsn('');
    setSelectedgrain('');
    setSelectedUnit('');
    setSelectedcoreid('');
    setSelectedremarks('');
    setselectedDiscountType('');
    setselectedOrderType('');
    setselectedPackageType('');

  }

  const openEdit = async (row) => {
    setMode('edit');
    setCurrent(row);
    await handleEditData(row);
    setFormState(row);
    SetpageTitle('Edit Product Detail');
    setOpen(true);
  };



  const handleEditData = async (row) => {

    // Product Group
    if (row.ProductGroupID) {
      // const selectGroup = dataProductgroup.find(g => g.CodeId === row.ProductGroupID);
      const selectGroup = dataProductgroup.find(g => g.CodeId === row.ProductGroupID?.toString());
      if (selectGroup) {
        setSelectedProductgroup(selectGroup);
        setFormState(prev => ({
          ...prev,
          ProductGroupID: selectGroup.CodeId,
        }));

        // Load subgroups before proceeding
        const subgroups = await fetchDataEdit('PRODUCT_SUBGROUP', selectGroup.CodeId);
        setOptionsProductSubgroup(subgroups || []);
      }
    }

    // Product Sub Group
    if (row.ProductSubGroupID) {
      const selectSubgroup = (optionsProductSubgroup.length > 0
        ? optionsProductSubgroup
        : await fetchDataEdit('PRODUCT_SUBGROUP', row.ProductGroupID?.toString())
      )?.find(sg => sg.CodeId === row.ProductSubGroupID);

      if (selectSubgroup) {
        setSelectedProductsubgroup(selectSubgroup);
        setFormState(prev => ({
          ...prev,
          ProductSubGroupID: selectSubgroup.CodeId,
        }));

        // Load varieties before proceeding
        const varieties = await fetchDataEdit('PRODUCT_VARIETY', selectSubgroup.CodeId);
        setOptionsVariety(varieties || []);
      }
    }

    // Product Variety
    if (row.ProductVarietyID) {
      const selectVariety = (optionsVariety.length > 0
        ? optionsVariety
        : await fetchDataEdit('PRODUCT_VARIETY', row.ProductSubGroupID?.toString())
      )?.find(v => v.CodeId === row.ProductVarietyID.toString());

      if (selectVariety) {

        setSelectedvariety(selectVariety);
        setFormState(prev => ({
          ...prev,
          VARIETY: selectVariety.Description,
          ProductVarietyID: selectVariety.CodeId,
        }));
      }
    }


    // grade
    if (row.GRADE !== undefined && row.GRADE !== null && row.GRADE !== '') {
      const selectGroup = dataGrade.find(g => g.CodeId === row.GRADE);
      if (!selectGroup) {
        alert('grade issue');
      }
      setSelectedgrade(selectGroup);
      setFormState(prevState => ({
        ...prevState,
        GRADE: selectGroup.CodeId,
      }));
    }

    // unit
    if (row.UNITTYPE !== undefined && row.UNITTYPE !== null && row.UNITTYPE !== '') {
      const selectGroup = dataUnitType.find(g => g.CodeId === row.UNITTYPE);
      if (!selectGroup) {
        alert('Unit issue');
      }
      setSelectedUnit(selectGroup);
      setFormState(prevState => ({
        ...prevState,
        UNITID: selectGroup.CodeId,
        UNITTYPE: selectGroup.Description,
      }));
    }

    // HSN
    if (row.HSNCode !== undefined && row.HSNCode !== null && row.HSNCode !== '') {
      const selectedHsn = dataHsn.find(g => g.hsncode === parseInt(row.HSNCode));
      if (selectedHsn) {
        setSelectedhsn(selectedHsn);
        setFormState(prevState => ({
          ...prevState,
          HSNCode: selectedHsn.CodeId,
          CGSTPERSENTAGE: selectedHsn.cgstpercent,
          SGSTPERSENTAGE: selectedHsn.sgstpercent,
          IGSTPERSENTAGE: selectedHsn.igstpercent,
        }));
      }
    }

    // core id
    if (row.COREID !== undefined && row.COREID !== null) {
      const selectGroup = dataCoreID.find(g => parseInt(g.CodeId) === parseInt(row.COREID));
      if (!selectGroup) {
        alert('coreid issue');
      }
      setSelectedcoreid(selectGroup);
      setFormState(prevState => ({
        ...prevState,
        COREID: selectGroup.CodeId,
      }));
    }

    // disount type
    if (row.DiscountType !== undefined && row.DiscountType !== null && row.DiscountType !== '') {
      const selectGroup = dataDiscountType.find(g => g.CodeId === row.DiscountType);
      if (!selectGroup) {
        alert('DiscountType issue');
      }
      setselectedDiscountType(selectGroup);
      setFormState(prevState => ({
        ...prevState,
        DiscountType: selectGroup.CodeId,
      }));
    }

    // order type
    if (row.OrderType !== undefined && row.OrderType !== null && row.OrderType !== '') {
      const selectGroup = dataOrderType.find(g => g.CodeId === row.OrderType);
      if (!selectGroup) {
        alert('OrderType issue');
      }
      setselectedOrderType(selectGroup);
      setFormState(prevState => ({
        ...prevState,
        OrderType: selectGroup.CodeId,
      }));
    }

    // package type
    if (row.PackageType !== undefined && row.PackageType !== null && row.PackageType !== '') {
      const selectGroup = dataPackageType.find(g => g.Description === row.PackageType);
      if (!selectGroup) {
        alert('OrderType issue');
      }
      setselectedPackageType(selectGroup);
      setFormState(prevState => ({
        ...prevState,
        PackageType: selectGroup.Description,
        PackageID: selectGroup.CodeId,
      }));
    }

    // remarks
    if (row.REMARKS !== undefined && row.REMARKS !== null && row.REMARKS !== '') {
      const selectGroup = dataRemarks.find(g => g.CodeId === row.REMARKS);
      if (!selectGroup) {
        alert('REMARKS issue');
      }
      setSelectedremarks(selectGroup);
      setFormState(prevState => ({
        ...prevState,
        REMARKS: selectGroup.CodeId,
      }));
    }

  };


  const closePopup = () => {
    setOpen(false);
    setCurrent(null);
  };


  const handlebackToadd = () => {
    setViewOrder(true);
    setViewReport(false);
  }



  // useEffect(() => {
  //   if (formState.length !== 0) {
  //     CalculateOrderQtyBasedOnReel();

  //   }


  // }, [
  //   formState.WIDTH,
  //   formState.LENGTH,
  //   formState.NOOFREELS,
  //   formState.REELOD,
  //   formState.UNITTYPE,
  //   formState.UnitOfMeasureCode,
  //   formState.RequestedQty,
  //   weightPerCMInKg,
  //   weightPerInchInKg
  // ]);

  return (
    <React.Fragment>

      {viewOrder && (

        <Box m="10px">

          <OrderActionButtons
            btnAdditionalDetailshow={btnAdditionalDetailshow}
            btnSaveUpdateOrdershow={btnSaveUpdateOrdershow}
            btnCancel={btnCancel}
            btnApproveOrdershow={btnApproveOrdershow}
            btnAmendmentshow={btnAmendmentshow}
            btnPrint={btnPrint}
            btnSaveOrderText="Save Order"
            openOrderAdditionalData={openOrderAdditionalData}
            handleOrdersSubmit={handleOrdersSubmit}
            handleShowCancelConfirmation={handleShowCancelConfirmation}
            handleCloseCancelConfirmation={handleCloseCancelConfirmation}
            openOrderCancel={openOrderCancel}
            openCancelConfirmation={openCancelConfirmation}
            handleShowApproveConfirmation={handleShowApproveConfirmation}
            handleCloseApproveConfirmation={handleCloseApproveConfirmation}
            handleApproveOrdersSubmit={handleApproveOrdersSubmit}
            openApproveConfirmation={openApproveConfirmation}
            handleShowAmendmentConfirmation={handleShowAmendmentConfirmation}
            handleCloseAmendmentConfirmation={handleCloseAmendmentConfirmation}
            AmendmentofOrder={AmendmentofOrder}
            openAmendmentConfirmation={openAmendmentConfirmation}
            handleViewReport={handleViewReport}
            title={headervalueset}
            callback={handlecallback}
          />
          <Stack>
            <CustomSnackbar
              open={snackbarOpen}
              message={alertMessage}
              onClose={handleSnackbarClose}
              type={alertsevierity}
            />
          </Stack>

          {loading && (
            <Box sx={{ width: "100%", mt: 1 }}>
              <LinearProgress
                variant="buffer"
                value={progress}
                valueBuffer={buffer}
                sx={progressStyles}
              />
            </Box>
          )}

          <Divider style={{ marginBottom: "5px", marginTop: "0px" }} />
          {/* Message box detail */}
          <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
            setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
            setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


          <Box
            sx={{

              padding: "5px",
              borderRadius: "10px",
              maxHeight: {
                xs: '72vh', // Extra small devices (phones)
                sm: '72vh', // Small devices (tablets)
                md: '74vh', // Medium devices (small laptops)
                lg: '74vh', // Large devices (desktops)
                xl: '82vh', // Extra large devices (large desktops)
              },
              overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                background: colors.primary[400],
                borderRadius: '10px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: colors.blueAccent[600],
                borderRadius: '10px',
                '&:hover': {
                  background: colors.blueAccent[800],
                },
              },
              '&::-webkit-scrollbar-corner': {
                background: colors.primary[700],
              }
            }}>


            <Grid container spacing={2} padding={1}>
              {/* 

            <Grid item xs={12}>
              <Grid container spacing={2} alignItems="center">
               
                <Grid item xs={12} sm={2} xl={1}>
                  <Typography variant="subtitle1">Order Type</Typography>
                </Grid>
                <Grid item xs={12} sm={4} xl={2}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    value={salesorderno}
                    label="CO No."
                    InputProps={{ readOnly: true }}
                  />
                </Grid>


              </Grid>
            </Grid> */}

              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                  {/* CO No */}
                  <Grid item xs={12} sm={2} xl={1}>
                    <Typography variant="subtitle1">CO. No</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} xl={2}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      value={salesorderno}
                      label="CO No."
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={2} xl={1.5}>
                    <Typography variant="subtitle1">Order Date</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} xl={2}>
                    <FormControl fullWidth size="small" error={!!indentdateError?.length}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="Order Date"
                          format="DD-MMM-YYYY"
                          value={dayjs(selectedDate)}
                          onChange={handleDateChange}
                          slotProps={{ textField: { size: "small", variant: "outlined" } }}
                        />
                      </LocalizationProvider>
                      {indentdateError && <FormHelperText>{indentdateError}</FormHelperText>}
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>



              {/* Example: Bill to Customer */}
              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={2} xl={1}>
                    <Typography variant="subtitle1">Bill to Customer</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} xl={2}>
                    <Autocomplete
                      fullWidth
                      size="small"
                      value={selectedCustomer || null}
                      onChange={handleSelectCustomer}
                      options={dataCustomer}
                      getOptionLabel={(option) => option.Description || ""}
                      isOptionEqualToValue={(option, value) => option.CodeId === value.CodeId}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Select Bill To "
                          error={!!billToCustomerError?.length}
                          helperText={billToCustomerError}
                          required
                        />
                      )}
                    />
                  </Grid>

                  {/* Ship to Customer */}
                  <Grid item xs={12} sm={2} xl={1.5}>
                    <Typography variant="subtitle1">Ship to Customer</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} xl={2}>
                    <Autocomplete
                      fullWidth
                      size="small"
                      id="dropdown_supplier" // Different id for Ship to Customer
                      value={selectedSupplier || null}
                      onChange={handleSelectSupplier}
                      options={dataSupplier}
                      getOptionLabel={(option) => option.Description || ''}
                      isOptionEqualToValue={(option, value) => option.CodeId === value.CodeId}
                      renderInput={(params) => (
                        <TextField {...params} variant="outlined" required
                          error={shipToCustomerError && shipToCustomerError.length ? true : false}
                          helperText={shipToCustomerError}
                          label="Select Ship to" />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Example: Shipment Mode and Transporter*/}
              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={2} xl={1}>
                    <Typography variant="subtitle1">Shipment Mode</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} xl={2} >
                    <Autocomplete
                      size='small'
                      value={selectedShipmentMode || null}
                      onChange={handleSelectShipmentMode}
                      options={dataShipmentmode}
                      getOptionLabel={(option) => option.Description || ''}
                      isOptionEqualToValue={(option, value) => option.CodeId === value.CodeId}
                      renderInput={(params) => (
                        <TextField {...params} label="Shipment mode"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>

                  {/* Transporter */}
                  <Grid item xs={12} sm={2} xl={1.5}>
                    <Typography variant="subtitle1"> Transporter</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} xl={2}>
                    <Autocomplete
                      size="small"
                      id="dropdown_Transporter"
                      fullWidth
                      value={selectedTransporter || null}

                      onChange={handleSelectTransporter}
                      options={dataTransporter}
                      getOptionLabel={(option) => option.Description || ''}
                      isOptionEqualToValue={(option, value) => option.CodeId === value.CodeId}
                      renderInput={(params) => (
                        <TextField {...params} label="Transporter"
                          error={transporterError && transporterError.length ? true : false}

                          helperText={transporterError}
                          variant="outlined" />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Divider sx={{ marginTop: '20px' }} />
              </Grid>

              {/* Example: Price List and Payment Term*/}
              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={2} xl={1}>
                    <Typography variant="subtitle1"> Price List</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} xl={2}>
                    <Autocomplete
                      size="small"
                      fullWidth
                      id="dropdown_pricelist" // Different id for Ship to Customer
                      value={selectedPriceList || null}
                      onChange={handleSelectPricelist}
                      options={dataPriceList}
                      getOptionLabel={(option) => option.Description || ''}
                      isOptionEqualToValue={(option, value) => option.CodeId === value.CodeId}
                      renderInput={(params) => (
                        <TextField {...params} label="Price List" variant="outlined"
                          error={priceListError && priceListError.length ? true : false}
                          required
                          helperText={priceListError}
                        />
                      )}
                    />
                  </Grid>

                  {/* Transporter */}
                  <Grid item xs={12} sm={2} xl={1.5}>
                    <Typography variant="subtitle1">  Payment Term</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} xl={2}>
                    <Autocomplete
                      size='small'
                      value={selectedPaymentTerm || null}
                      onChange={handleSelectPaymentTerm}
                      options={dataPaymentterm}
                      getOptionLabel={(option) => option.Description || ''}
                      isOptionEqualToValue={(option, value) => option.CodeId === value.CodeId}
                      renderInput={(params) => (
                        <TextField {...params} label="Payment term" variant="outlined"
                          required
                          error={paymentTermError && paymentTermError.length ? true : false}
                          helperText={paymentTermError}
                        />
                      )}
                    />

                  </Grid>
                </Grid>
              </Grid>

              {/* Example: Credit Limit and Credit Limit Rules*/}
              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={2} xl={1}>
                    <Typography variant="subtitle1">  Credit Limit</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} xl={2}>
                    <Autocomplete
                      size='small'
                      value={selectedCreditTerm || null}
                      onChange={handleSelectCreditTerm}
                      options={dataCreditterm}
                      getOptionLabel={(option) => option.Description || ''}
                      isOptionEqualToValue={(option, value) => option.CodeId === value.CodeId}
                      renderInput={(params) => (
                        <TextField {...params} label="Credit Limit" variant="outlined"
                        />
                      )}
                    />
                  </Grid>

                  {/* Transporter */}
                  <Grid item xs={12} sm={2} xl={1.5}>
                    <Typography variant="subtitle1">Credit Limit Rules</Typography>
                  </Grid>

                  <Grid item xs={12} sm={4} xl={2}>
                    <Autocomplete
                      size='small'
                      value={selectedCreditTermRule || null}
                      onChange={handleSelectCreditTermRule}
                      options={dataCredittermRule}
                      getOptionLabel={(option) => option.Description || ''}
                      isOptionEqualToValue={(option, value) => option.CodeId === value.CodeId}
                      renderInput={(params) => (
                        <TextField {...params} label="Credit Limit rule" variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Divider sx={{ marginTop: '20px' }} />
              </Grid>
              {/* Example:  PO No and PO Date*/}
              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={2} xl={1} >
                    <Typography variant="subtitle1"> PO No</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} xl={2}>
                    <TextField fullWidth size="small" onChange={handleSelectPoNo} value={SRefNo} label="Party PO No" variant="outlined" />
                  </Grid>


                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={2} xl={1}>
                    <Typography variant="subtitle1"> PO Date</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} xl={2}>
                    <FormControl fullWidth size="small" error={poDateError && poDateError.length ? true : false}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Stack spacing={2}>
                          <DatePicker
                            label="PO date"
                            id="POdate"
                            fullWidth
                            format='DD-MMM-YYYY'
                            value={dayjs(poDate)}
                            onChange={handlePODateChange}
                            slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
                            className="customDatePicker"
                            renderInput={(props) => (
                              <TextField required {...props} variant="outlined" />
                            )}
                          />
                        </Stack>
                      </LocalizationProvider>
                      {indentdateError && indentdateError.length > 0 && (
                        <FormHelperText error>{indentdateError}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  {/* Transporter */}
                  <Grid item xs={12} sm={2} xl={1.5}>
                    <Typography variant="subtitle1">Schedule date</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} xl={2}>
                    <FormControl fullWidth size="small">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Stack spacing={2} >
                          <DatePicker onChange={handleScheduleDateChange} format='DD-MMM-YYYY' value={dayjs(scheduleDate)} slotProps={{ textField: { size: 'small', variant: 'outlined' } }} label="Schedule date" />
                        </Stack>
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>

              {/* <FormControl fullWidth size="small" error={!!indentdateError?.length}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Order Date"
                        format="DD-MMM-YYYY"
                        value={dayjs(selectedDate)}
                        onChange={handleDateChange}
                        slotProps={{ textField: { size: "small", variant: "outlined" } }}
                      />
                    </LocalizationProvider>
                    {indentdateError && <FormHelperText>{indentdateError}</FormHelperText>}
                  </FormControl> */}

              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={2} xl={1}>
                    <Typography variant="subtitle1">  Region</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} xl={2}>
                    <TextField fullWidth size="small" label="Region" value={region} onChange={(e) => SetSRegion(e.target.value)} variant="outlined" />
                  </Grid>

                  {/* Transporter */}
                  <Grid item xs={12} sm={2} xl={1.5}>
                    <Typography variant="subtitle1"> Delivery Area</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} xl={2}>
                    <TextField fullWidth size="small" label="Delivery Area" value={regionDeliveryArea} onChange={(e) => SetRegionDeliveryArea(e.target.value)} variant="outlined" />
                  </Grid>
                </Grid>
              </Grid>

              {/* <Grid item xs={12}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={2} xl={1}>
                  <Typography variant="subtitle1">Reason</Typography>
                </Grid>
                <Grid item xs={12} sm={4} xl={2}>
                  <TextField fullWidth size="small" label="Reason" value={reason} onChange={(e) => SetSReason(e.target.value)} variant="outlined" />
                </Grid>
              </Grid>
            </Grid> */}

              {/* Example:  Remarks*/}
              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={2} xl={1}>
                    <Typography variant="subtitle1"> Remarks</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField fullWidth size="small" label="Remarks" value={SRemarks} onChange={handleSelectRemarks} variant="outlined" />
                  </Grid>
                </Grid>
              </Grid>

              {visibleAmendmentReason &&
                <Grid item xs={12}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={2} xl={1}>
                      <Typography variant="subtitle1"> Amendment Reason</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField fullWidth size="small"
                        error={amendReasonError && amendReasonError.length ? true : false}
                        required
                        helperText={amendReasonError}
                        label="Amendment Reason"
                        // style={{ marginLeft: '8px' }}
                        value={SAmendmentReason} onChange={handleSelectAmendmentReason} variant="outlined" />
                    </Grid>
                  </Grid>
                </Grid>

              }
              {/* Continue the same pattern for Ship To, Supplier, Transporter, etc. */}
            </Grid>

            <Divider sx={{ marginTop: '10px' }} />

            <Box sx={{
              backgroundColor: 'transparent',
              display: 'flex',
              padding: 0.5,
              justifyContent: 'space-between',
              alignItems: 'center',
              // color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#FFFFFF',
            }} >


              <Box >


                {/* Blur effect when the dialog is open */}
                {open && (
                  <div style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backdropFilter: 'blur(2px)', // Adjust the blur intensity
                    zIndex: 1000, // Adjust the z-index to be above other content
                  }}
                  ></div>
                )}

                <Dialog open={open} onClose={closePopup} fullWidth maxWidth="lg">
                  <DialogContent sx={{ backgroundColor: theme.palette.background.default }}>
                    <ProductForm
                      formKey={mode === 'add' ? 'new' : `edit-${current?.id ?? 'x'}`}
                      initialValues={initialForForm}
                      pageTitle={pageTitle}
                      closePopup={closePopup}

                      formState={formState}
                      handleChange={handleChange}
                      handleProductSubmit={handleProductSubmit}

                      selectedProductgroup={selectedProductgroup}
                      selectedProductsubgroup={selectedProductsubgroup}
                      selectedvariety={selectedvariety}
                      selectedgrade={selectedgrade}
                      selectedhsn={selectedhsn}
                      selectedgrain={selectedgrain}
                      selectedUnit={selectedUnit}
                      selectedcoreid={selectedcoreid}
                      selectedDiscountType={selectedDiscountType}
                      selectedOrderType={selectedOrderType}
                      selectedPackageType={selectedPackageType}
                      selectedremarks={selectedremarks}

                      handleSelectProductgroup={handleSelectProductgroup}
                      handleSelectProductsubgroup={handleSelectProductsubgroup}
                      handleSelectvariety={handleSelectvariety}
                      handleSelectgrade={handleSelectgrade}
                      handleSelecthsn={handleSelectHsn}
                      handleSelectgrain={handleSelectgrain}
                      handleSelectUnit={handleSelectUnit}
                      handleSelectcoreid={handleSelectcoreid}
                      handleSelectDiscountType={handleSelectDiscountType}
                      handleSelectOrderType={handleSelectOrderType}
                      handleSelectPackageType={handleSelectPackageType}
                      handleSelectremarks={handleSelectremarks}

                      dataProductgroup={dataProductgroup}
                      optionsProductSubgroup={optionsProductSubgroup}
                      optionsVariety={optionsVariety}
                      dataGrade={dataGrade}
                      dataHsn={dataHsn}
                      datagrain={datagrain}
                      dataUnit={dataUnitType}
                      dataCoreID={dataCoreID}
                      dataDiscountType={dataDiscountType}
                      dataOrderType={dataOrderType}
                      dataPackageType={dataPackageType}
                      dataRemarks={dataRemarks}

                      ProductGroupError={ProductGroupError}
                      ProductSubGroupError={ProductSubGroupError}
                      ProductVarietyError={ProductVarietyError}
                      GradeError={GradeError}
                      HSNError={HSNError}
                      GSMError={GSMError}
                      WidthError={WidthError}
                      ReelODError={ReelODError}
                      CoreIDError={CoreIDError}
                      NoOfSheetsError={NoOfSheetsError}
                      RequiredQtyError={RequiredQtyError}
                      COQtyError={COQtyError}
                      UnitpriceError={UnitpriceError}
                      BillingRateError={BillingRateError}
                      PackageTypeError={PackageTypeError}
                      disabledCoreID={disabledCoreID}
                      disabledNoofSheets={disabledNoofSheets}
                      disabledReelOD={disabledReelOD}

                      snackbarOpen={snackbarOpen}
                      alertMessage={alertMessage}
                      alertsevierity={alertsevierity}
                      handleSnackbarClose={handleSnackbarClose}
                    />


                  </DialogContent>
                </Dialog>


                {openProductItem && (
                  <div style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backdropFilter: 'blur(2px)', // Adjust the blur intensity
                    zIndex: 1000, // Adjust the z-index to be above other content
                  }}
                  ></div>
                )}
                <Dialog open={openProductItem} onClose={closeProductItemListPopup} maxWidth={'md'} TransitionComponent={Transition}
                  keepMounted aria-describedby="alert-dialog-slide-description">
                  <DialogContent style={{ backgroundColor: theme.palette.background.default }}>
                    <ProductItemList closeModal={() => {
                      setOpenProductItem(false);
                    }}
                      closePopup={closePopupProductItemList} onSubmit={handleProductItemList} />
                  </DialogContent>
                </Dialog>



                {openCancelOrder && (
                  <div style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backdropFilter: 'blur(2px)', // Adjust the blur intensity
                    zIndex: 1000, // Adjust the z-index to be above other content
                  }}
                  ></div>
                )}

                <Dialog open={openCancelOrder} onClose={closeCancelOrderPopup} maxWidth={'xl'} TransitionComponent={Transition}
                  keepMounted aria-describedby="alert-dialog-slide-description">
                  <DialogContent style={{ backgroundColor: theme.palette.background.default }}>
                    <OrderCancel closeModal={() => {
                      setopenCancelOrder(false);
                    }}
                      closePopup={closeCancelOrderPopup} onSubmit={handleCancelOrder} />
                  </DialogContent>
                </Dialog>
              </Box>
            </Box>




            <Box
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
                md: 'repeat(3, 1fr)',
                lg: 'repeat(10, 1fr)',
                xl: 'repeat(10, 1fr)',
              }}
              overflow="auto"
              gap={{ xs: '50px', sm: '50px', md: '50px', lg: '10px', xl: '10px' }}
            >

              <Box gridColumn="span 10" gridRow="span 2">
                <Box sx={{ overflowX: 'auto' }}>

                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        {columns.map((col, idx) => (
                          <TableCell
                            key={col.field}
                            sx={{
                              width: col.width ? col.width : 'auto',
                              minWidth: col.width ? col.width : 80,
                              position: col.pinned === 'left' ? 'sticky' : 'static',
                              left: col.pinned === 'left' ? (leftOffsets[idx] ?? 0) : 'auto',
                              zIndex: col.pinned === 'left' ? 2 : 1, // keep header above body
                              whiteSpace: 'nowrap',
                              fontWeight: 600,
                              backgroundColor: 'background.paper',
                            }}
                          >
                            {col.headerName || (col.field === 'actions' ? '' : col.field)}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {rows.map((row, rowIndex) => (
                        <TableRow key={row.id ?? rowIndex} hover sx={{ height: 35 }}>
                          {columns.map((col, colIndex) => {
                            if (col.field === 'actions') {
                              return (
                                <TableCell
                                  key={`${col.field}-${colIndex}`}
                                  sx={{
                                    position: col.pinned === 'left' ? 'sticky' : 'static',
                                    left: col.pinned === 'left' ? (leftOffsets[colIndex] ?? 0) : 'auto',
                                    zIndex: col.pinned === 'left' ? 1 : 'auto',
                                    width: col.width || 80,
                                    minWidth: col.width || 80,
                                    whiteSpace: 'nowrap',
                                    backgroundColor: col.pinned === 'left' ? 'background.paper' : 'inherit',
                                  }}
                                >
                                  <span className="actions">
                                    {rowEditAndDelete && (
                                      <Tooltip title="Edit">
                                        <IconButton
                                          aria-label="edit"
                                          // onClick={() => handleEditRow?.(row)}
                                          onClick={() => openEdit?.(row)}

                                          size="small"
                                        >
                                          <EditIcon sx={{ color: '#388e3c' }} fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                    {rowEditAndDelete && (
                                      <Tooltip title="Delete">
                                        <IconButton
                                          aria-label="delete"
                                          onClick={() => handleDeleteRow?.(row)}
                                          size="small"
                                        >
                                          <CloseIcon sx={{ color: '#c75f6b' }} fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    )}


                                    {/* New Cancel Button */}
                                    {rowEditAndDelete && (
                                      <Tooltip title="Cancel Line Item">
                                        <IconButton
                                          aria-label="cancel"
                                          onClick={() => handleCancelRow?.(row)}
                                          size="small"
                                        >
                                          <CancelIcon sx={{ color: '#876812ff' }} fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                  </span>
                                </TableCell>
                              );
                            }

                            const value = row[col.field];

                            return (
                              <TableCell
                                key={`${col.field}-${colIndex}`}
                                sx={{
                                  width: col.width ? col.width : 'auto',
                                  minWidth: col.width ? col.width : 80,
                                  position: col.pinned === 'left' ? 'sticky' : 'static',
                                  left: col.pinned === 'left' ? (leftOffsets[colIndex] ?? 0) : 'auto',
                                  zIndex: col.pinned === 'left' ? 1 : 'auto',
                                  whiteSpace: 'nowrap',
                                  backgroundColor: col.pinned === 'left' ? 'background.paper' : 'inherit',
                                }}
                                align={typeof value === 'number' ? 'right' : 'left'}
                              >
                                {value ?? ''}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))}
                      {rows.length === 0 && (
                        <TableRow>
                          <TableCell colSpan={columns.length} align="center" sx={{ py: 3 }}>
                            No records found
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>

                </Box>
              </Box>
            </Box>

            <Box marginTop={2}>
              <ToggleButtonGroup
                value={alignment}
                exclusive
                onChange={handleAlignment}
                aria-label="products actions"
              >
                {btnAddProduct && (
                  <Tooltip title="Add Product">
                    <Button
                      variant="contained"
                      style={{ fontSize: '11px', textTransform: 'none' }}
                      size="small"
                      color="secondary"
                      startIcon={<Add />}
                      // onClick={openPopup}
                      onClick={openAdd}
                    >
                      Add Product
                    </Button>
                  </Tooltip>
                )}
                {btnAddProduct && (
                  <Tooltip title="Select Product Items">
                    <Button
                      variant="contained"
                      style={{ marginLeft: '5px', fontSize: '11px', textTransform: 'none' }}
                      size="small"
                      color="secondary"
                      startIcon={<Add />}
                      onClick={openProductItemList}
                    >
                      Add Products in Bulk
                    </Button>
                  </Tooltip>
                )}
              </ToggleButtonGroup>
            </Box>
            <Box mt={2} display="flex" justifyContent="flex-end">
              <Box width={{ xs: '100%', md: 500, lg: 560 }}>
                <SummaryLedger
                  values={totals}
                  onChange={handleSummaryChange}
                />
              </Box>
            </Box>

          </Box>
        </Box>
      )}

      {viewReport && (
        <SalesOrderReport orderData={orderData} handleBackToSalesOrderDetails={handlebackToadd} totals={totals} />
        // <COMANAGEMENT handleBackWinderMachineEntry={handlebackToadd} />
      )}
    </React.Fragment>
  );
};

export default AddNewOrder;